// import React, { useState, useEffect, useRef } from "react";
// import { motion } from "framer-motion";
// import axios from "axios";
// import "./index.css";

// export default function KiteDisplayPage() {
//   const groundOffset = 80; // adjust so it touches hands/grass
//   const [kiteUrl, setKiteUrl] = useState([]);
//   const [kiteUrlChange, setKiteUrlChange] = useState([]);
//   const containerRef = useRef(null);
//   const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
//   const [seenKites, setSeenKites] = useState(new Set());
//   const [kitePositions, setKitePositions] = useState(new Map());
//   const [newKiteAnimations, setNewKiteAnimations] = useState(new Map());
//   const [handPositions, setHandPositions] = useState(new Map());
//   const SAFE_EDGE = Math.max(0, Math.round(dimensions.width * 0.01+50)); // increase if still clipping
//   // Put your hand images in /assets folder
//   const handImages = [
//     "/assets/person1.png",
//     "/assets/person2.png",
//     "/assets/person3.png",
//     "/assets/person5.png",
//     "/assets/person6.png",
//     // "/assets/person7.png",
//     "/assets/person8.png",
//     "/assets/person9.png",
//     "/assets/person10.png",
//     "/assets/person11.png",
//     "/assets/person12.png",
//     "/assets/person13.png",
//     "/assets/person14.png",
//     // "/assets/hand6.png",
//     // "/assets/hand8.webp",
//     // "/assets/hand9.webp",
//     // "/assets/hand10.webp",
//     // "/assets/hand11.png",
//   ];

//   // Array of colorful thread colors
//   const threadColors = [
//     "#FF6B6B",
//     "#4ECDC4",
//     "#FFD93D",
//     "#6B5B95",
//     "#88D8B0",
//     "#FFA07A",
//     "#20B2AA",
//     "#DA70D6",
//     "#F0E68C",
//     "#98D8C8",
//     "#FFB6C1",
//     "#7B68EE",
//     "#32CD32",
//     "#FF6347",
//     "#9370DB",
//   ];

//   // Enhanced ground elements with better distribution
//   const generateGroundElements = () => {
//     const grassBlades = Array.from({ length: 80 }, (_, i) => ({
//       id: i,
//       x: Math.random() * 100,
//       height: 12 + Math.random() * 25,
//       width: 1.5 + Math.random() * 2.5,
//       color: `hsl(${85 + Math.random() * 15}, ${65 + Math.random() * 20}%, ${
//         30 + Math.random() * 15
//       }%)`,
//       sway: 2 + Math.random() * 8,
//       delay: Math.random() * 5,
//     }));

//     const smallRocks = Array.from({ length: 25 }, (_, i) => ({
//       id: i,
//       x: Math.random() * 100,
//       y: Math.random() * 8,
//       size: 2 + Math.random() * 10,
//       color: `hsl(${25 + Math.random() * 15}, ${25 + Math.random() * 15}%, ${
//         35 + Math.random() * 25
//       }%)`,
//     }));

//     const flowers = Array.from({ length: 12 }, (_, i) => ({
//       id: i,
//       x: Math.random() * 100,
//       y: 3 + Math.random() * 6,
//       size: 5 + Math.random() * 10,
//       color: `hsl(${Math.random() * 360}, 75%, 65%)`,
//       type: i % 4,
//     }));

//     return { grassBlades, smallRocks, flowers };
//   };

//   const { grassBlades, smallRocks, flowers } = generateGroundElements();

//   // NEW: Calculate optimal kite and hand positions that fill available space first
//   const calculateOptimalPositions = (
//     kites,
//     containerWidth,
//     containerHeight
//   ) => {
//     const handPositionsMap = new Map();
//     const kitePositionsMap = new Map();

//     const numKites = kites.length;
//     if (numKites === 0) return { handPositionsMap, kitePositionsMap };

//     // Calculate optimal grid layout
//     const maxFrontRowKites = Math.min(16, numKites); // Maximum kites in front row
//     const frontRowKites = Math.min(numKites, maxFrontRowKites);
//     const backRowKites = Math.max(0, numKites - frontRowKites);
//     const frontRowCount = Math.min(numKites, maxFrontRowKites);
//     const handWidth = 50;
//     const minSpacing = 0;
//     // near top of component, after dimensions state is set/available
//     const sideMargin = SAFE_EDGE;
//     // Calculate avai1lable width (container width minus margins)
//     const availableWidth = containerWidth - 2 * sideMargin;
//     // Calculate front row positions (evenly spaced, priority)
//     // Function to calculate uniform hand positions for a row
//     const getRowPositions = (rowCount, rowYOffset = 0) => {
//       const spacing = (availableWidth - rowCount * handWidth) / (rowCount + 1);
//       const positions = [];
//       for (let i = 0; i < rowCount; i++) {
//         const handX = sideMargin + spacing * (i + 1) + handWidth * i;
//         const handY =
//           containerHeight - Math.min(120, containerHeight * 0.2) + rowYOffset;
//         positions.push({ handX, handY });
//       }
//       return positions;
//     };
//     const frontRowSpacing = Math.max(
//       minSpacing * 0.8,
//       (availableWidth - frontRowKites * handWidth) /
//         Math.max(1, frontRowKites + 1)
//     );
//     let frontRowStartX =
//       sideMargin +
//       (availableWidth -
//         (frontRowKites * handWidth +
//           Math.max(0, frontRowKites - 1) * frontRowSpacing)) /
//         2;
//     const frontPositions = getRowPositions(frontRowCount);
//     // Front row kites (fill available space first)
//     for (let i = 0; i < frontRowKites; i++) {
//       const kite = kites[i];
//       const { handX, handY } = frontPositions[i];
//       // Kite position - front row (lower height for better visibility)
//       const kiteY = handY - 120 - (i % 3) * 15;
//       const kiteX = handX; /// Align with hand

//       handPositionsMap.set(String(kite.kitePhotoId), {
//         x: handX, // Use kiteX instead of handX to ensure exact alignment
//         y: handY,
//         rotation: -10 + (i % 5) * 5, // More varied rotation
//         row: "front",
//       });

//       kitePositionsMap.set(String(kite.kitePhotoId), {
//         x: kiteX,
//         y: kiteY,
//         size: 90 + Math.random() * 30,
//         color: threadColors[i % threadColors.length],
//         handIndex: i % handImages.length,
//         row: "front",
//         zIndex: 10,
//       });
//     }

//     // Back row kites (only if front row is full)
//     if (backRowKites > 0) {
//       const backRowSpacing = Math.max(
//         minSpacing * 0.8,
//         (availableWidth - backRowKites * handWidth) /
//           Math.max(1, backRowKites + 1)
//       );
//       let backRowStartX =
//         sideMargin +
//         (availableWidth -
//           (backRowKites * handWidth +
//             Math.max(0, backRowKites - 1) * backRowSpacing)) /
//           2;
//       for (let i = 0; i < backRowKites; i++) {
//         const kiteIndex = frontRowKites + i;
//         const kite = kites[kiteIndex];
//         const handX = backRowStartX + i * (handWidth + backRowSpacing);
//         const handY = containerHeight * 0.88 + (i % 3) * 3 - 3;
//         // Kite position - back row (higher and smaller)
//         const kiteY = Math.max(
//           60,
//           Math.min(containerHeight * 0.4, 80 + (i % 3) * 15)
//         );
//         const kiteX = handX + (i % 2 === 0 ? -30 : 30); // Slight offset for natural look
//         handPositionsMap.set(String(kite.kitePhotoId), {
//           x: handX,
//           y: handY,
//           rotation: -5 + (i % 3) * 5,
//           row: "back",
//         });
//         kitePositionsMap.set(String(kite.kitePhotoId), {
//           x: Math.max(
//             sideMargin + 20,
//             Math.min(containerWidth - sideMargin - 20, kiteX)
//           ), // Ensure within bounds
//           y: kiteY,
//           size: 60 + Math.random() * 25, // Smaller back row kites
//           color: threadColors[(frontRowKites + i) % threadColors.length],
//           handIndex: (frontRowKites + i) % handImages.length,
//           row: "back",
//           zIndex: 5,
//         });
//       }
//     }
//     return { handPositionsMap, kitePositionsMap };
//   };

//   const fetchKites = async () => {
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_API_URL}all`);
//       const kites = response.data;
//       setKiteUrl(kites);

//       // Generate optimal positions for all kites
//       if (dimensions.width > 0 && dimensions.height > 0) {
//         const { handPositionsMap, kitePositionsMap } =
//           calculateOptimalPositions(kites, dimensions.width, dimensions.height);

//         setHandPositions(handPositionsMap);
//         setKitePositions(kitePositionsMap);
//         setSeenKites(new Set(kites.map((kite) => String(kite.kitePhotoId))));
//       }
//     } catch (err) {
//       console.error("get failed", err);
//     }
//   };

//   const fetchKites2 = async () => {
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_API_URL}all`);
//       setKiteUrlChange(response.data);
//     } catch (err) {
//       console.error("get failed", err);
//     }
//   };

//   useEffect(() => {
//     const updateSize = () => {
//       if (containerRef.current) {
//         const { width, height } = containerRef.current.getBoundingClientRect();
//         setDimensions({
//           width: containerRef.current.offsetWidth,
//           height: containerRef.current.offsetHeight,
//         });
//       }
//     };
//     updateSize();
//     window.addEventListener("resize", updateSize);

//     // Also update on load complete
//     window.addEventListener("load", updateSize);

//     return () => {
//       window.removeEventListener("resize", updateSize);
//       window.removeEventListener("load", updateSize);
//     };
//   }, []);

//   useEffect(() => {
//     fetchKites();
//   }, [dimensions]);

//   useEffect(() => {
//     const interval = setInterval(fetchKites2, 1000);
//     return () => clearInterval(interval);
//   }, []);

//   useEffect(() => {
//     if (
//       kiteUrlChange.length === 0 ||
//       dimensions.width === 0 ||
//       dimensions.height === 0
//     )
//       return;

//     const newKites = kiteUrlChange.filter(
//       (kite) => !seenKites.has(String(kite.kitePhotoId))
//     );

//     if (newKites.length > 0) {
//       // Update seen kites first
//       setSeenKites((prev) => {
//         const updated = new Set(prev);
//         newKites.forEach((kite) => updated.add(String(kite.kitePhotoId)));
//         return updated;
//       });

//       // Add new kites to display
//       setKiteUrl((prev) => [...prev, ...newKites]);

//       // Recalculate ALL positions with new kites (this will automatically fill gaps first)
//       setTimeout(() => {
//         const allKites = [...kiteUrl, ...newKites];
//         const { handPositionsMap, kitePositionsMap } =
//           calculateOptimalPositions(
//             allKites,
//             dimensions.width,
//             dimensions.height
//           );

//         setHandPositions(handPositionsMap);
//         setKitePositions(kitePositionsMap);

//         // Set animation for new kites
//         const newAnimations = new Map();
//         newKites.forEach((kite) =>
//           newAnimations.set(String(kite.kitePhotoId), {
//             stage: "entrance",
//             startTime: Date.now(),
//           })
//         );
//         setNewKiteAnimations(newAnimations);

//         // Remove animation after 2 seconds
//         setTimeout(() => {
//           setNewKiteAnimations((prev) => {
//             const updated = new Map(prev);
//             newKites.forEach((kite) =>
//               updated.delete(String(kite.kitePhotoId))
//             );
//             return updated;
//           });
//         }, 4000);
//       }, 100);
//     }
//   }, [kiteUrlChange, dimensions, seenKites, kiteUrl]);
//   const calculateThreadPath = (
//     handX,
//     handY,
//     handRotation,
//     kiteX,
//     kiteY,
//     windStrength = 0
//   ) => {
//     if (
//       [handX, handY, kiteX, kiteY].some((v) => v == null || Number.isNaN(v))
//     ) {
//       return "M 0 0 L 0 0";
//     }
//     // clamp helper
//     const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
//     // Calculate hand rotation offset for more realistic thread start
//     const rotationRad = (handRotation * Math.PI) / 180;
//     let threadStartX = handX + Math.sin(rotationRad) * 8;
//     const threadStartY = Math.min(
//       handY - 20,
//       dimensions.width - Math.min(120, dimensions.height * 0.2)
//     );
//     const threadEndY = Math.max(kiteY, 20);
//     const minX = SAFE_EDGE;
//     const maxX = Math.max((dimensions.width || 0) - SAFE_EDGE, SAFE_EDGE + 1);
//     const kiteSize = Math.min(90 + Math.random() * 30, dimensions.width / 10);

//     threadStartX = clamp(threadStartX, minX, maxX);
//     const clampedKiteX = clamp(kiteX, minX, maxX);

//     const distance = Math.sqrt(
//       Math.pow(clampedKiteX - threadStartX, 2) +
//         Math.pow(kiteY - threadStartY, 2)
//     );
//     const midX = (threadStartX + clampedKiteX) / 2;
//     const midY = (threadStartY + kiteY) / 2;
//     // More natural curve based on distance and wind
//     // More natural curve based on distance and wind
//     const curveIntensity = Math.min(distance * 0.3, 80);

//     const control1X = clamp(
//       midX - curveIntensity * 0.3 + windStrength * 8,
//       minX,
//       maxX
//     );
//     const control1Y = midY + curveIntensity * 0.2;

//     const control2X = clamp(
//       midX + curveIntensity * 0.4 + windStrength * 12,
//       minX,
//       maxX
//     );
//     const control2Y = midY + curveIntensity * 0.15;

//     return `M ${threadStartX} ${threadStartY} C ${control1X} ${control1Y}, ${control2X} ${control2Y}, ${clampedKiteX} ${kiteY}`;
//   };
//   // Get kite flight pattern
//   const getKiteFlightPattern = (index, row) => {
//     const baseRotation = 45;
//     const rotationRange = row === "front" ? 8 : 6; // More movement in front row
//     const rotationSpeed = row === "front" ? 4 + (index % 3) : 6 + (index % 2);

//     return {
//       rotate: [
//         baseRotation,
//         baseRotation + rotationRange,
//         baseRotation - rotationRange / 2,
//         baseRotation + rotationRange / 2,
//         baseRotation - rotationRange,
//         baseRotation,
//       ],
//       duration: rotationSpeed,
//     };
//   };

//   // Get wind variations
//   const getWindVariations = (index, row) => {
//     const baseStrength =
//       row === "front" ? [0, 3, -2, 4, -3, 2, 0] : [0, 2, -1, 3, -2, 1, 0];
//     return baseStrength.map((strength) => strength * (0.5 + (index % 3) * 0.2));
//   };
//   // Get animation positions based on current dimensions
//   const getAnimationPositions = (position) => {
//     if (!dimensions.width || !dimensions.height) {
//       return {
//         startX: 0,
//         startY: 0,
//         centerX: 0,
//         centerY: 0,
//         finalX: 0,
//         finalY: 0,
//       };
//     }

//     const finalX = position.x - position.size / 2;
//     const finalY = position.y - position.size / 2;
//     const centerX = dimensions.width / 2 - position.size / 2;
//     const centerY = dimensions.height / 2 - position.size / 2;
//     const startX = dimensions.width + 100;
//     const startY = dimensions.height + 100;

//     return {
//       startX,
//       startY,
//       centerX,
//       centerY,
//       finalX,
//       finalY,
//     };
//   };
//   // New kite entrance animation sequence
//   const getNewKiteAnimation = (position, dimensions, kiteId) => {
//     const centerX = dimensions.width / 2 - position.size / 2;
//     const centerY = dimensions.height / 2 - position.size / 2;
//     const finalX = position.x - position.size / 2;
//     const finalY = position.y - position.size / 2;

//     const animationState = newKiteAnimations.get(String(kiteId));

//     if (animationState?.stage === "entrance") {
//       return {
//         x: [dimensions.width + 150, centerX],
//         y: [dimensions.height + 150, centerY],
//         scale: [0.5, 1],
//         opacity: [0, 1],
//         rotate: [-90, 0],
//         transition: { duration: 1.4, ease: "easeOut" },
//       };
//     } else if (animationState?.stage === "center") {
//       return {
//         x: centerX,
//         y: centerY,
//         scale: [1, 1.8, 1.5],
//         rotate: [0, 360],
//         opacity: 1,
//         transition: {
//           duration: 1.2,
//           ease: "easeInOut",
//         },
//       };
//     } else if (animationState?.stage === "toPosition") {
//       return {
//         x: [centerX, finalX],
//         y: [centerY, finalY],
//         scale: [1.5, 1],
//         rotate: [360, 45],
//         opacity: [1, position.row === "front" ? 1 : 0.8],
//         transition: { duration: 1.3, ease: "easeInOut" },
//       };
//     }

//     // Default idle (already in place)
//     return {
//       x: finalX,
//       y: finalY,
//       scale: 1,
//       rotate: 0,
//       opacity: position.row === "front" ? 1 : 0.8,
//     };
//   };

//   // Handle animation stage progression
//   useEffect(() => {
//     const advanceAnimationStage = (kiteId) => {
//       setNewKiteAnimations((prev) => {
//         const updated = new Map(prev);
//         const current = updated.get(String(kiteId));

//         if (!current) return prev;

//         if (current.stage === "entrance") {
//           updated.set(String(kiteId), { ...current, stage: "center" });
//           setTimeout(() => advanceAnimationStage(kiteId), 1200);
//         } else if (current.stage === "center") {
//           updated.set(String(kiteId), { ...current, stage: "toPosition" });
//           setTimeout(() => advanceAnimationStage(kiteId), 1300);
//         } else if (current.stage === "toPosition") {
//           // Animation complete, remove from new animations
//           setTimeout(() => {
//             setNewKiteAnimations((prev) => {
//               const finalUpdated = new Map(prev);
//               finalUpdated.delete(String(kiteId));
//               return finalUpdated;
//             });
//           }, 1300);
//         }

//         return updated;
//       });
//     };

//     // Start animation sequence for new kites
//     newKiteAnimations.forEach((value, kiteId) => {
//       if (value.stage === "entrance") {
//         setTimeout(() => advanceAnimationStage(kiteId), 1500);
//       }
//     });
//   }, [newKiteAnimations]);

//   return (
//     <div
//       ref={containerRef}
//       style={{
//         //textAlign: "center",
//         overflow: "hidden",
//         height: "100vh",
//         width: "100vw",
//         // maxWidth: "100%", // Add this
//         position: "relative",
//         background: "linear-gradient(to bottom, #87CEEB 70%, #E0F7FF 100%)",
//       }}
//     >
//       {/* Clouds */}
//       {[
//         {
//           top: "5%",
//           src: "/assets/cloud.png",
//           left: "10%",
//           size: "1px",
//           dir: "right",
//         },
//         {
//           top: "20%",
//           src: "/assets/cloud.png",
//           left: "50%",
//           size: "4px",
//           dir: "left",
//           opacity: 0.9,
//         },
//         {
//           top: "10%",
//           src: "/assets/cloud.png",
//           left: "40%",
//           size: "6px",
//           dir: "right",
//         },
//         {
//           top: "20%",
//           src: "/assets/cloud.png",
//           left: "20%",
//           size: "5px",
//           dir: "left",
//           opacity: 0.6,
//         },
//         {
//           top: "8%",
//           src: "/assets/cloud.png",
//           left: "85%",
//           size: "6px",
//           dir: "right",
//         },
//         {
//           top: "15%",
//           src: "/assets/cloud.png",
//           left: "70%",
//           size: "6px",
//           dir: "left",
//           opacity: 0.6,
//         },
//       ].map((cloud, i) => (
//         <motion.div
//           key={i}
//           animate={{
//             x: cloud.dir === "right" ? ["0%", "100%"] : ["100%", "0%"],
//           }}
//           transition={{
//             duration: 30 + i * 5,
//             repeat: Infinity,
//             ease: "linear",
//           }}
//           style={{
//             position: "absolute",
//             top: cloud.top,
//             left: cloud.left,
//             fontSize: cloud.size,
//             opacity: cloud.opacity ?? 1,
//             pointerEvents: "none",
//           }}
//         >
//           <img
//             src={cloud.src}
//             style={{ width: "120px", height: "120px" }}
//             alt="cloud"
//           />
//         </motion.div>
//       ))}

//       {/* Kites with their own hands */}
//       {kiteUrl.map((url, index) => {
//         const position = kitePositions.get(String(url.kitePhotoId));
//         const handPosition = handPositions.get(String(url.kitePhotoId));

//         if (!position || !handPosition) return null;
//         if (isNaN(position.x) || isNaN(position.y)) return null;

//         const threadColor = position.color;
//         const isNew = newKiteAnimations.has(String(url.kitePhotoId));
//         const flight = getKiteFlightPattern(index, position.row);
//         const windVariations = getWindVariations(index, position.row);
//         const handImageIndex = position.handIndex;
//         // Get responsive animation positions
//         const { startX, startY, centerX, centerY, finalX, finalY } =
//           getAnimationPositions(position);
//         return (
//           <div
//             key={String(url.kitePhotoId)}
//             style={{ position: "absolute", width: "100%", height: "100%" }}
//           >
//             {/* Thread */}
//             <motion.svg
//               style={{
//                 position: "absolute",
//                 left: 45, // give extra space
//                 top: 0,
//                 width: "100%", // oversize the width
//                 // width: dimensions.width ? `${dimensions.width}px` : "100%",
//                 height: "100%",
//                 overflow: "visible",
//                 pointerEvents: "none",
//               }}
//               viewBox={`0 0 ${dimensions.width || 1000} ${
//                 dimensions.height || 1000
//               }`}
//               preserveAspectRatio="xMidYMid meet"
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               transition={{ duration: 0.5 }}
//             >
//               {!isNaN(handPosition.x) &&
//                 !isNaN(handPosition.y) &&
//                 !isNaN(handPosition.rotation) &&
//                 !isNaN(position.x) &&
//                 !isNaN(position.y) && (
//                   <motion.path
//                     d={calculateThreadPath(
//                       handPosition.x,
//                       handPosition.y,
//                       handPosition.rotation,
//                       position.x,
//                       position.y,
//                       windVariations[0] ?? 0
//                     )}
//                     stroke={threadColor}
//                     strokeWidth={position.row === "front" ? "2" : "1.5"}
//                     fill="transparent"
//                     strokeLinecap="round"
//                     style={{
//                       filter: `
//                         drop-shadow(1px 1px 2px rgba(0,0,0,0.3))
//                         url(#thread-glow-${index})
//                       `,

//                       opacity: position.row === "front" ? 0.9 : 0.7,
//                     }}
//                     animate={{
//                       d: windVariations
//                         .filter((wind) => typeof wind === "number")
//                         .map((wind) =>
//                           calculateThreadPath(
//                             handPosition.x,
//                             handPosition.y,
//                             handPosition.rotation,
//                             position.x,
//                             position.y,
//                             wind ?? 0
//                           )
//                         ),
//                     }}
//                     transition={{
//                       duration:
//                         position.row === "front"
//                           ? 8 + (index % 6)
//                           : 12 + (index % 4),
//                       repeat: Infinity,
//                       ease: "easeInOut",
//                       delay: index * 0.3,
//                     }}
//                   />
//                 )}
//               {/* Add glow filter for thread */}
//               <defs>
//                 <filter id={`thread-glow-${index}`}>
//                   <feGaussianBlur stdDeviation="1" result="coloredBlur" />
//                   <feMerge>
//                     <feMergeNode in="coloredBlur" />
//                     <feMergeNode in="SourceGraphic" />
//                   </feMerge>
//                 </filter>
//               </defs>
//             </motion.svg>

//             {/* Kite */}
//             <motion.img
//               key={url._id}
//               src={`${process.env.REACT_APP_API_URL}file/${url.kitePhotoId}`}
//               alt={`Kite ${index + 1}`}
//               x={position.x - position.size / 2}
//               y={position.y - position.size / 2}
//               preserveAspectRatio="xMidYMid meet"
//               style={{
//                 position: "absolute",
//                 left:45,
//                 right:45,
//                 // left: position.x - position.size / 2,
//                 // top: position.y - position.size / 2,
//                 width: position.size,
//                 height: position.size,
//                 objectFit: "contain",
//                 filter: `drop-shadow(4px 4px 8px rgba(0,0,0,0.3)) 
//                          ${position.row === "back" ? "brightness(0.9)" : ""}`,
//                 borderRadius: "5px",
//                 zIndex: isNew ? 999 : position.zIndex,
//               }}
//               // initial={
//               //   isNew
//               //     ? {
//               //         x: dimensions.width + 200,
//               //         y: dimensions.height + 200,
//               //         scale: 1.5,
//               //         opacity: 0,
//               //         rotate: 0,
//               //       }
//               //     : {
//               //         x: 0,
//               //         y: 0,
//               //         scale: 1,
//               //         opacity: position.row === "front" ? 1 : 0.8,
//               //         rotate: 0,
//               //       }
//               // }
//               animate={
//                 // isNew
//                 //    ?
//                     getNewKiteAnimation(
//                 position,
//                 dimensions,
//                 url.kitePhotoId
//               )
//                   // : {
//                   //     rotate:
//                   //       position.row === "front"
//                   //         ? [45, 45 + 8, 45 - 4, 45 + 4, 45 - 8, 45]
//                   //         : [45, 45 + 4, 45 - 2, 45 + 2, 45 - 4, 45],
//                   //   }
//                   }
//               initial={false}
//               // animate={
//               //   isNew
//               //     ? {
//               //         x: [dimensions.width + 100, centerX, centerX, finalX],
//               //         y: [dimensions.height + 100, centerY, centerY, finalY],
//               //         scale: [0.3, 1, 1.8, 1],
//               //         opacity: [0, 1, 1, position.row === "front" ? 1 : 0.8],
//               //         rotate: [-180, 0, 360, 45],
//               //       }
//               //     : {
//               //         x:
//               //           finalX +
//               //           (position.row === "front"
//               //             ? [2, -8, 3, 3, 0]
//               //             : [1, -4, 2, 2, 0]),
//               //         rotate:
//               //           position.row === "front"
//               //             ? [45, 45 + 8, 45 - 4, 45 + 4, 45 - 8, 45]
//               //             : [45, 45 + 4, 45 - 2, 45 + 2, 45 - 4, 45],
//               //       }
//               // }
//               transition={
//                 isNew
//                   ? {
//                       duration: 4,
//                       times: [0, 0.35, 0.5, 1],
//                       ease: ["easeOut", "easeInOut", "easeOut"],
//                       rotate: {
//                         duration: 4,
//                         times: [0, 0.35, 0.65, 1],
//                         ease: ["easeOut", "linear", "easeOut"],
//                       },
//                     }
//                   : {
//                       duration: position.row === "front" ? 6 : 10,
//                       repeat: Infinity,
//                       repeatType: "loop",
//                       ease: "easeInOut",
//                     }
//               }
//             />

//             {/* Hand */}
//             <motion.div
//               key={`hand-${url.kitePhotoId}`}
//               initial={{ opacity: 0, y: 20 }}
//               animate={{
//                 opacity: 1,
//                 y: 0,
//                 scale: 1,
//                 rotateZ: handPosition.rotation,
//               }}
//               transition={{
//                 duration: 1.5,
//                 ease: "easeOut",
//                 delay: 0.2,
//                 rotateZ: {
//                   duration: 8,
//                   repeat: Infinity,
//                   repeatType: "reverse",
//                   ease: "easeInOut",
//                   delay: index * 0.5,
//                 },
//               }}
//               style={{
//                 position: "absolute",
//                 left: Math.min(
//                   Math.max(handPosition.x, SAFE_EDGE),
//                   dimensions.width - SAFE_EDGE - 60
//                 ),
//                 top: handPosition.y - 70, // Reduced from 80 to 70 for better positioning
//                 zIndex: 18,
//                 transformOrigin: "bottom center",
//                  pointerEvents: "none",
//               }}
//             >
//               <img
//                 src={handImages[handImageIndex]}
//                 x={handPosition.x - 40}
//                 y={handPosition.y - 70}
//                 transform={`rotate(${handPosition.rotation}, ${handPosition.x}, ${handPosition.y})`}
//                 style={{
//                   width: 60,
//                 height: 86,
//                   // height: `${85 + (index % 1) * 20}px`,
//                   objectFit: "contain",
//                    transform: `rotate(${handPosition.rotation}deg)`,
//                   filter: `
//                     drop-shadow(2px 4px 6px rgba(0,0,0,0.4))
//                     brightness(${position.row === "front" ? 1 : 0.9})
//                   `,
//                   pointerEvents: "none",
//                 }}
//                 alt="hand holding kite"
//               />
//               <div
//                 style={{
//                   position: "absolute",
//                   top: "1px", // Adjust based on hand image
//                   left: "50%",
//                   width: "4px",
//                   height: "4px",
//                   background: "red",
//                   borderRadius: "50%",
//                   transform: "translateX(-50%)",
//                   background:
//                     "linear-gradient(to top, #2E7D32 0%, #388E3C 30%, #4CAF50 70%)", // DARKER GREEN GRADIENT
//                   display: "none", // Set to "block" to see connection point
//                 }}
//               />
//             </motion.div>
//           </div>
//         );
//       })}

//       {/* Enhanced Ground */}
//       <div
//         style={{
//           position: "absolute",
//           bottom: 0,
//           left: 0,
//           width: "100%",
//           height: "17vh",
//           zIndex: 15,
//           overflow: "hidden",
//           background:
//             "linear-gradient(to top, #2E7D32 0%, #388E3C 30%, #4CAF50 70%)",
//         }}
//       >
//         {/* Grass overlay */}
//         <div
//           style={{
//             position: "absolute",
//             bottom: 10,
//             left: 0,
//             width: "100%",
//             height: "65%",
//           }}
//         />

//         {/* Animated grass blades */}
//         {grassBlades.map((blade) => (
//           <motion.div
//             key={blade.id}
//             style={{
//               position: "absolute",
//               bottom: "15%",
//               left: `${blade.x}%`,
//               width: `${blade.width}px`,
//               height: `${blade.height}px`,
//               background: blade.color,
//               clipPath: "polygon(40% 0%, 60% 0%, 100% 100%, 0% 100%)",
//               transformOrigin: "bottom center",
//               zIndex: 16,
//               boxShadow: "1px 1px 2px rgba(0,0,0,0.3)",
//             }}
//             animate={{
//               rotateZ: [-blade.sway, blade.sway, -blade.sway],
//             }}
//             transition={{
//               duration: 2.5 + Math.random() * 2,
//               repeat: Infinity,
//               ease: "easeInOut",
//               delay: blade.delay,
//             }}
//           />
//         ))}

//         {/* Rocks and flowers... */}
//         {smallRocks.map((rock) => (
//           <div
//             key={rock.id}
//             style={{
//               position: "absolute",
//               bottom: `${rock.y}%`,
//               left: `${rock.x}%`,
//               width: `${rock.size}px`,
//               height: `${rock.size * 0.6}px`,
//               background: rock.color,
//               borderRadius: "30% 70% 60% 40% / 40% 60% 70% 60%",
//               boxShadow: `
//                   2px 2px 4px rgba(0,0,0,0.4),
//                   inset -1px -1px 2px rgba(0,0,0,0.3)
//                 `,
//               zIndex: 15,
//             }}
//           />
//         ))}

//         {flowers.map((flower) => (
//           <motion.div
//             key={flower.id}
//             style={{
//               position: "absolute",
//               bottom: `${flower.y}%`,
//               left: `${flower.x}%`,
//               width: `${flower.size}px`,
//               height: `${flower.size}px`,
//               background: flower.color,
//               borderRadius:
//                 flower.type === 0
//                   ? "50%"
//                   : flower.type === 1
//                   ? "50% 50% 0 0"
//                   : flower.type === 2
//                   ? "40% 60% 70% 30% / 50% 60% 40% 50%"
//                   : "30% 70% 70% 30% / 50% 50% 50% 50%",
//               boxShadow: "0 3px 6px rgba(0,0,0,0.3)",
//               zIndex: 16,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               fontSize: `${flower.size * 0.4}px`,
//               color: "rgba(255,255,255,0.9)",
//             }}
//             animate={{
//               y: [0, -3, 0],
//               rotateZ: [0, 5, 0, -5, 0],
//             }}
//             transition={{
//               duration: 4 + Math.random() * 4,
//               repeat: Infinity,
//               ease: "easeInOut",
//               delay: Math.random() * 2,
//             }}
//           >
//             {flower.type === 3 ? "✿" : ""}
//           </motion.div>
//         ))}
//       </div>

//       {/* Enhanced Wind Effects */}
//       {[1, 2, 3].map((wind) => (
//         <motion.div
//           key={wind}
//           animate={{
//             opacity: [0, 0.4, 0],
//             x:
//               wind % 2 === 0
//                 ? ["-50px", "calc(100% + 50px)"]
//                 : ["calc(100% + 50px)", "-50px"],
//           }}
//           transition={{
//             duration: 8 + wind * 2,
//             repeat: Infinity,
//             delay: wind * 1.5,
//             ease: "linear",
//           }}
//           style={{
//             position: "absolute",
//             top: `${20 + wind * 15}%`,
//             left: wind % 2 === 0 ? "-50px" : "100%",
//             zIndex: 1,
//             opacity: 0.3,
//           }}
//         >
//           <img
//             src="/assets/windy1.png"
//             style={{
//               width: "60px",
//               height: "60px",
//               filter: "brightness(1.2)",
//             }}
//             alt="wind effect"
//           />
//         </motion.div>
//       ))}
//     </div>
//   );
// }


// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { motion } from "framer-motion";
// import axios from "axios";
// import "./index.css";

// export default function KiteDisplayPage() {
//   const groundOffset = 80;
//   const [kiteUrl, setKiteUrl] = useState([]);
//   const [kiteUrlChange, setKiteUrlChange] = useState([]);
//   const containerRef = useRef(null);
//   const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
//   const seenKitesRef = useRef(new Set());
//   const [kitePositions, setKitePositions] = useState(new Map());
//   const newKiteAnimationsRef = useRef(new Map());
//   const [handPositions, setHandPositions] = useState(new Map());
//   const SAFE_EDGE = Math.max(0, Math.round((dimensions.width * 0.01) + 50));

//   const handImages = React.useMemo(() => [
//     "/assets/person1.png",
//     "/assets/person2.png",
//     "/assets/person3.png",
//     "/assets/person5.png",
//     "/assets/person6.png",
//     "/assets/person8.png",
//     "/assets/person9.png",
//     "/assets/person10.png",
//     "/assets/person11.png",
//     "/assets/person12.png",
//     "/assets/person13.png",
//     "/assets/person14.png",
//   ], []);

//   const threadColors = React.useMemo(() => [
//     "#FF6B6B", "#4ECDC4", "#FFD93D", "#6B5B95", "#88D8B0",
//     "#FFA07A", "#20B2AA", "#DA70D6", "#F0E68C", "#98D8C8",
//     "#FFB6C1", "#7B68EE", "#32CD32", "#FF6347", "#9370DB",
//   ], []);

//   const groundElements = React.useMemo(() => {
//     const grassBlades = Array.from({ length: 40 }, (_, i) => ({
//       id: i,
//       x: Math.random() * 100,
//       height: 12 + Math.random() * 25,
//       width: 1.5 + Math.random() * 2.5,
//       color: `hsl(${85 + Math.random() * 15}, ${65 + Math.random() * 20}%, ${
//         30 + Math.random() * 15
//       }%)`,
//       sway: 2 + Math.random() * 8,
//       delay: Math.random() * 5,
//     }));

//     const smallRocks = Array.from({ length: 15 }, (_, i) => ({
//       id: i,
//       x: Math.random() * 100,
//       y: Math.random() * 8,
//       size: 2 + Math.random() * 10,
//       color: `hsl(${25 + Math.random() * 15}, ${25 + Math.random() * 15}%, ${
//         35 + Math.random() * 25
//       }%)`,
//     }));

//     const flowers = Array.from({ length: 8 }, (_, i) => ({
//       id: i,
//       x: Math.random() * 100,
//       y: 3 + Math.random() * 6,
//       size: 5 + Math.random() * 10,
//       color: `hsl(${Math.random() * 360}, 75%, 65%)`,
//       type: i % 4,
//     }));

//     return { grassBlades, smallRocks, flowers };
//   }, []);

//   const { grassBlades, smallRocks, flowers } = groundElements;

//   // Calculate kite position based on thread end point
//   const calculateKitePosition = useCallback((handX, handY, handRotation, threadLength = 150) => {
//     const angle = -30 + Math.random() * 40; // Angle variation for natural look
//     const angleRad = (angle * Math.PI) / 180;
    
//     // Calculate kite position at the end of the thread
//     const kiteX = handX + Math.sin(angleRad) * threadLength;
//     const kiteY = handY - Math.cos(angleRad) * threadLength;
    
//     return { kiteX, kiteY, angle };
//   }, []);

//   const calculateRandomPositions = useCallback((kites, containerWidth, containerHeight) => {
//     if (!containerWidth || !containerHeight) return { handPositionsMap: new Map(), kitePositionsMap: new Map() };

//     const handPositionsMap = new Map();
//     const kitePositionsMap = new Map();
//     const numKites = kites.length;
//     if (numKites === 0) return { handPositionsMap, kitePositionsMap };

//     const sideMargin = 40;
//      const availableWidth = containerWidth - (sideMargin * 2);
//     const groundAreaTop = containerHeight * 0.85;
//     const groundAreaHeight = containerHeight - groundAreaTop;
//     const handWidth = 60;
//     const minSpacing = 80;

//     const positions = [];
//     const usedPositions = new Set();

//     for (let i = 0; i < numKites; i++) {
//       let attempts = 0;
//       let validPosition = false;
//       let handX, handY;

//       while (!validPosition && attempts < 50) {
//         handX = sideMargin + Math.random() * availableWidth;
//         handY = groundAreaTop + Math.random() * (groundAreaHeight - 86 - 10);
        
//         validPosition = true;
//         for (const pos of usedPositions) {
//           const [existingX, existingY] = pos.split(',').map(Number);
//           const distance = Math.sqrt(
//             Math.pow(handX - existingX, 2) + Math.pow(handY - existingY, 2)
//           );
//           if (distance < minSpacing) {
//             validPosition = false;
//             break;
//           }
//         }
//         attempts++;
//       }

//       if (validPosition) {
//         const kite = kites[i];
//         const positionKey = `${Math.round(handX)},${Math.round(handY)}`;
//         usedPositions.add(positionKey);

//         // Calculate kite position based on thread
//         const threadLength = 120 + Math.random() * 80;
//         const { kiteX, kiteY, angle } = calculateKitePosition(handX, handY, 0, threadLength);

//         // Ensure kite stays within bounds
//         const boundedKiteX = Math.max(
//           sideMargin + 40,
//           Math.min(containerWidth - sideMargin - 40, kiteX)
//         );
//         const boundedKiteY = Math.max(80, Math.min(containerHeight * 0.16, kiteY));

//         handPositionsMap.set(String(kite.kitePhotoId), {
//           x: handX,
//           y: handY,
//           rotation: -10 + Math.random() * 20,
//           threadLength: threadLength,
//         });

//         kitePositionsMap.set(String(kite.kitePhotoId), {
//           x: boundedKiteX,
//           y: boundedKiteY,
//           size: 70 + Math.random() * 40,
//           color: threadColors[i % threadColors.length],
//           handIndex: i % handImages.length,
//           zIndex: 5 + Math.floor(Math.random() * 10),
//           angle: angle, // Store the angle for animation
//         });

//         positions.push({ handX, handY });
//       }
//     }

//     return { handPositionsMap, kitePositionsMap };
//   }, [SAFE_EDGE, threadColors, handImages, calculateKitePosition]);

//   const fetchKites = useCallback(async () => {
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_API_URL}all`);
//       const kites = response.data;
//       setKiteUrl(kites);

//       if (dimensions.width > 0 && dimensions.height > 0) {
//         const { handPositionsMap, kitePositionsMap } = calculateRandomPositions(
//           kites, 
//           dimensions.width, 
//           dimensions.height
//         );

//         setHandPositions(handPositionsMap);
//         setKitePositions(kitePositionsMap);
//         seenKitesRef.current = new Set(kites.map((kite) => String(kite.kitePhotoId)));
//       }
//     } catch (err) {
//       console.error("get failed", err);
//     }
//   }, [dimensions, calculateRandomPositions]);

//   const fetchKites2 = useCallback(async () => {
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_API_URL}all`);
//       setKiteUrlChange(response.data);
//     } catch (err) {
//       console.error("get failed", err);
//     }
//   }, []);

//   useEffect(() => {
//     const updateSize = () => {
//       if (containerRef.current) {
//         setDimensions({
//           width: containerRef.current.offsetWidth,
//           height: containerRef.current.offsetHeight,
//         });
//       }
//     };

//     let resizeTimeout;
//     const handleResize = () => {
//       clearTimeout(resizeTimeout);
//       resizeTimeout = setTimeout(updateSize, 250);
//     };

//     updateSize();
//     window.addEventListener("resize", handleResize);
//     window.addEventListener("load", updateSize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//       window.removeEventListener("load", updateSize);
//       clearTimeout(resizeTimeout);
//     };
//   }, []);

//   useEffect(() => {
//     const timeoutId = setTimeout(() => {
//       if (dimensions.width > 0 && dimensions.height > 0) {
//         fetchKites();
//       }
//     }, 100);
    
//     return () => clearTimeout(timeoutId);
//   }, [dimensions, fetchKites]);

//   useEffect(() => {
//     const interval = setInterval(fetchKites2, 2000);
//     return () => clearInterval(interval);
//   }, [fetchKites2]);

//   useEffect(() => {
//     if (kiteUrlChange.length === 0 || dimensions.width === 0 || dimensions.height === 0) return;

//     const newKites = kiteUrlChange.filter(
//       (kite) => !seenKitesRef.current.has(String(kite.kitePhotoId))
//     );

//     if (newKites.length > 0) {
//       newKites.forEach((kite) => seenKitesRef.current.add(String(kite.kitePhotoId)));
      
//       setKiteUrl((prev) => {
//         const updated = [...prev, ...newKites];
        
//         setTimeout(() => {
//           const { handPositionsMap, kitePositionsMap } = calculateRandomPositions(
//             updated,
//             dimensions.width,
//             dimensions.height
//           );

//           setHandPositions(handPositionsMap);
//           setKitePositions(kitePositionsMap);

//           newKites.forEach((kite) =>
//             newKiteAnimationsRef.current.set(String(kite.kitePhotoId), {
//               stage: "entrance",
//               startTime: Date.now(),
//             })
//           );

//           setTimeout(() => {
//             newKites.forEach((kite) =>
//               newKiteAnimationsRef.current.delete(String(kite.kitePhotoId))
//             );
//           }, 4000);
//         }, 100);

//         return updated;
//       });
//     }
//   }, [kiteUrlChange, dimensions, calculateRandomPositions]);

//   // Calculate thread path that ends exactly at kite position
//   const calculateThreadPath = useCallback((
//     handX,
//     handY,
//     handRotation,
//     kiteX,
//     kiteY
//   ) => {
//     if ([handX, handY, kiteX, kiteY].some((v) => v == null || Number.isNaN(v))) {
//       return "M 0 0 L 0 0";
//     }

//     const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
//     const rotationRad = (handRotation * Math.PI) / 180;
    
//     // Thread starts from hand position
//     let threadStartX = handX + Math.sin(rotationRad) * 8;
//     const threadStartY = handY - 15;
    
//     const minX = SAFE_EDGE;
//     const maxX = Math.max((dimensions.width || 0) - SAFE_EDGE, SAFE_EDGE + 1);

//     threadStartX = clamp(threadStartX, minX, maxX);
//     const clampedKiteX = clamp(kiteX, minX, maxX);

//     const distance = Math.sqrt(
//       Math.pow(clampedKiteX - threadStartX, 2) + Math.pow(kiteY - threadStartY, 2)
//     );
    
//     // Calculate control points for a natural curve
//     const midX = (threadStartX + clampedKiteX) / 2;
//     const midY = (threadStartY + kiteY) / 2;
    
//     // Curve intensity based on distance
//     const curveIntensity = Math.min(distance * 0.2, 60);
    
//     // Control points for Bezier curve
//     const control1X = midX - curveIntensity;
//     const control1Y = midY + curveIntensity * 0.3;
    
//     const control2X = midX + curveIntensity;
//     const control2Y = midY + curveIntensity * 0.2;

//     // The thread path MUST end exactly at the kite position
//     return `M ${threadStartX} ${threadStartY} C ${control1X} ${control1Y}, ${control2X} ${control2Y}, ${clampedKiteX} ${kiteY}`;
//   }, [SAFE_EDGE, dimensions.width]);

//   // Get wind variations for thread animation
//   const getWindVariations = useCallback((index) => {
//     const baseStrength = [0, 1, -0.5, 1.5, -1, 0.5, 0];
//     return baseStrength.map((strength) => strength * (0.3 + (index % 3) * 0.1));
//   }, []);

//   // Get kite animation that follows the thread end point
//   const getKiteAnimation = useCallback((position, kiteId) => {
//     const isNew = newKiteAnimationsRef.current.has(String(kiteId));
    
//     if (isNew) {
//       const centerX = (dimensions.width / 2) - (position.size / 2);
//       const centerY = (dimensions.height / 2) - (position.size / 2);
//       const finalX = position.x - position.size / 2;
//       const finalY = position.y - position.size / 2;

//       return {
//         x: [dimensions.width + 150, centerX, finalX],
//         y: [dimensions.height + 150, centerY, finalY],
//         scale: [0.5, 1.2, 1],
//         opacity: [0, 1, 1],
//         rotate: [-90, 0, position.angle || 45],
//         transition: {
//           duration: 3,
//           times: [0, 0.5, 1],
//           ease: ["easeOut", "easeInOut"],
//         },
//       };
//     }

//     // Regular kite animation - subtle movement around the thread end point
//     return {
//       x: position.x - position.size / 2,
//       y: position.y - position.size / 2,
//       rotate: [position.angle || 45, (position.angle || 45) + 5, (position.angle || 45) - 3, position.angle || 45],
//       scale: 1,
//       opacity: 1,
//       transition: {
//         rotate: {
//           duration: 8,
//           repeat: Infinity,
//           ease: "easeInOut"
//         }
//       }
//     };
//   }, [dimensions]);

//   const clouds = React.useMemo(() => [
//     { top: "5%", left: "10%", dir: "right" },
//     { top: "20%", left: "50%", dir: "left", opacity: 0.9 },
//     { top: "10%", left: "40%", dir: "right" },
//     { top: "20%", left: "20%", dir: "left", opacity: 0.6 },
//     { top: "8%", left: "85%", dir: "right" },
//     { top: "15%", left: "70%", dir: "left", opacity: 0.6 },
//   ], []);

//   const windEffects = React.useMemo(() => [1, 2, 3], []);

//   // Memoized Kite Component with proper thread-kite connection
//   const KiteWithHand = React.useCallback(({ url, index }) => {
//     const position = kitePositions.get(String(url.kitePhotoId));
//     const handPosition = handPositions.get(String(url.kitePhotoId));

//     if (!position || !handPosition) return null;
//     if (isNaN(position.x) || isNaN(position.y)) return null;

//     const threadColor = position.color;
//     const windVariations = getWindVariations(index);
//     const handImageIndex = position.handIndex;

//     return (
//       <React.Fragment key={String(url.kitePhotoId)}>
//         {/* Thread that connects hand to kite */}
//         <motion.svg
//           style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             overflow: "visible",
//             pointerEvents: "none",
//             zIndex: 30,

//           }}
//           viewBox={`0 0 ${dimensions.width || 1000} ${dimensions.height || 1000}`}
//           preserveAspectRatio="none"
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ duration: 0.3 }}
//         >
//           <motion.path
//             d={calculateThreadPath(
//               handPosition.x,
//               handPosition.y,
//               handPosition.rotation,
//               position.x,
//               position.y
//             )}
//             stroke={threadColor}
//             strokeWidth="1.5"
//             fill="transparent"
//             strokeLinecap="round"
//             style={{
//               filter: `drop-shadow(1px 1px 1px rgba(0,0,0,0.2))`,
//               opacity: 0.8,
//             }}
//             animate={{
//               d: windVariations.map((wind) => {
//                 // Apply wind effect to thread curve
//                 const adjustedKiteX = position.x + wind * 10;
//                 const adjustedKiteY = position.y + wind * 5;
//                 return calculateThreadPath(
//                   handPosition.x,
//                   handPosition.y,
//                   handPosition.rotation,
//                   adjustedKiteX,
//                   adjustedKiteY
//                 );
//               }),
//             }}
//             transition={{
//               duration: 12 + (index % 4),
//               repeat: Infinity,
//               ease: "easeInOut",
//             }}
//           />
//         </motion.svg>

//         {/* Kite positioned exactly at thread end point */}
//         <motion.img
//          key={url._id}
//           src={`${process.env.REACT_APP_API_URL}file/${url.kitePhotoId}`}
//           alt={`Kite ${index + 1}`}
//            x={position.x - position.size / 2}
//               y={position.y - position.size / 2}
//           style={{
//             position: "absolute",
//             left:5,
//                  right:5, // Center kite at thread end point
//             width: position.size,
//             height: position.size,
//             objectFit: "contain",
//             filter: `drop-shadow(2px 2px 4px rgba(0,0,0,0.2))`,
//             borderRadius: "5px",
//             zIndex: position.zIndex,
//             transformOrigin: "center center", // Rotate from center
//           }}
//           animate={getKiteAnimation(position, url.kitePhotoId)}
//           initial={false}
//         />

//         {/* Hand */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{
//             opacity: 1,
//             y: 0,
//             rotateZ: handPosition.rotation,
//           }}
//           transition={{
//             duration: 1,
//             ease: "easeOut",
//           }}
//           style={{
//             position: "absolute",
//             left: handPosition.x - 30,
//             top: handPosition.y - 70,
//                       zIndex: 30,
//             transformOrigin: "bottom center",
//             pointerEvents: "none",
//           }}
//         >
//           <img
//             src={handImages[handImageIndex]}
//             style={{
//               width: 50,
//               height: 72,
//               objectFit: "contain",
//               filter: `drop-shadow(1px 2px 3px rgba(0,0,0,0.3))`,
//               pointerEvents: "none",
//             }}
//             alt="hand holding kite"
//             loading="lazy"
//           />
//         </motion.div>
//       </React.Fragment>
//     );
//   }, [kitePositions, handPositions, dimensions, calculateThreadPath, getWindVariations, getKiteAnimation, handImages]);

//   return (
//     <div
//       ref={containerRef}
//       style={{
//         overflow: "hidden",
//         height: "100vh",
//         width: "100vw",
//         position: "relative",
//         background: "linear-gradient(to bottom, #87CEEB 70%, #E0F7FF 100%)",
//         willChange: "transform",
//       }}
//     >
//       {/* Clouds */}
//       {clouds.map((cloud, i) => (
//         <motion.div
//           key={i}
//           animate={{
//             x: cloud.dir === "right" ? ["0%", "100%"] : ["100%", "0%"],
//           }}
//           transition={{
//             duration: 40 + i * 10,
//             repeat: Infinity,
//             ease: "linear",
//           }}
//           style={{
//             position: "absolute",
//             top: cloud.top,
//             left: cloud.left,
//             opacity: cloud.opacity ?? 1,
//             pointerEvents: "none",
//           }}
//         >
//           <img
//             src="/assets/cloud.png"
//             style={{ width: "100px", height: "100px" }}
//             alt="cloud"
//             loading="lazy"
//           />
//         </motion.div>
//       ))}

//       {/* Kites with their own hands */}
//       {kiteUrl.map((url, index) => (
//         <KiteWithHand key={String(url.kitePhotoId)} url={url} index={index} />
//       ))}

//       {/* Ground */}
//       <div
//         style={{
//           position: "absolute",
//           bottom: 0,
//           left: 0,
//           width: "100%",
//           height: "22vh",
//           zIndex: 20,
//           overflow: "hidden",
//           background: "linear-gradient(to top, #2E7D32, #4CAF50)",
//         }}
//       >
//         {grassBlades.map((blade) => (
//           <motion.div
//             key={blade.id}
//             style={{
//               position: "absolute",
//               bottom: "10%",
//               left: `${blade.x}%`,
//               width: `${blade.width}px`,
//               height: `${blade.height}px`,
//               background: blade.color,
//               clipPath: "polygon(40% 0%, 60% 0%, 100% 100%, 0% 100%)",
//               transformOrigin: "bottom center",
//               zIndex: 21,
//             }}
//             animate={{
//               rotateZ: [-blade.sway * 0.7, blade.sway * 0.7, -blade.sway * 0.7],
//             }}
//             transition={{
//               duration: 3 + Math.random() * 2,
//               repeat: Infinity,
//               ease: "easeInOut",
//               delay: blade.delay,
//             }}
//           />
//         ))}

//         {smallRocks.map((rock) => (
//           <div
//             key={rock.id}
//             style={{
//               position: "absolute",
//               bottom: `${rock.y}%`,
//               left: `${rock.x}%`,
//               width: `${rock.size}px`,
//               height: `${rock.size * 0.6}px`,
//               background: rock.color,
//               borderRadius: "30% 70% 60% 40% / 40% 60% 70% 60%",
//               zIndex: 19,
//             }}
//           />
//         ))}

//         {flowers.map((flower) => (
//           <div
//             key={flower.id}
//             style={{
//               position: "absolute",
//               bottom: `${flower.y}%`,
//               left: `${flower.x}%`,
//               width: `${flower.size}px`,
//               height: `${flower.size}px`,
//               background: flower.color,
//               borderRadius: "50%",
//               zIndex: 20,
//             }}
//           />
//         ))}
//       </div>

//       {/* Wind effects */}
//       {windEffects.map((wind) => (
//         <motion.div
//           key={wind}
//           animate={{
//             opacity: [0, 0.3, 0],
//             x: wind % 2 === 0 ? ["-50px", "calc(100% + 50px)"] : ["calc(100% + 50px)", "-50px"],
//           }}
//           transition={{
//             duration: 12 + wind * 3,
//             repeat: Infinity,
//             delay: wind * 2,
//             ease: "linear",
//           }}
//           style={{
//             position: "absolute",
//             top: `${20 + wind * 15}%`,
//             left: wind % 2 === 0 ? "-50px" : "100%",
//             zIndex: 1,
//           }}
//         >
//           <img
//             src="/assets/windy1.png"
//             style={{
//               width: "40px",
//               height: "40px",
//               opacity: 0.4,
//             }}
//             alt="wind effect"
//             loading="lazy"
//           />
//         </motion.div>
//       ))}
//     </div>
//   );
// }

// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { motion } from "framer-motion";
// import axios from "axios";
// import "./index.css";

// export default function KiteDisplayPage() {
//   const groundOffset = 80;
//   const [kiteUrl, setKiteUrl] = useState([]);
//   const [kiteUrlChange, setKiteUrlChange] = useState([]);
//   const containerRef = useRef(null);
//   const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
//   const seenKitesRef = useRef(new Set());
//    const [seenKites, setSeenKites] = useState(new Set());
//   const [kitePositions, setKitePositions] = useState(new Map());
//   const newKiteAnimationsRef = useRef(new Map());
//   const [handPositions, setHandPositions] = useState(new Map());
//  const [newKiteAnimations, setNewKiteAnimations] = useState(new Map());
//   const handImages = React.useMemo(() => [
//     "/assets/person1.png",
//     "/assets/person2.png",
//     "/assets/person3.png",
//     "/assets/person5.png",
//     "/assets/person6.png",
//     "/assets/person8.png",
//     "/assets/person9.png",
//     "/assets/person10.png",
//     "/assets/person11.png",
//     "/assets/person12.png",
//     "/assets/person13.png",
//     "/assets/person14.png",
//   ], []);

//   const threadColors = React.useMemo(() => [
//     "#FF6B6B", "#4ECDC4", "#FFD93D", "#6B5B95", "#88D8B0",
//     "#FFA07A", "#20B2AA", "#DA70D6", "#F0E68C", "#98D8C8",
//     "#FFB6C1", "#7B68EE", "#32CD32", "#FF6347", "#9370DB",
//   ], []);

//   const groundElements = React.useMemo(() => {
//     const grassBlades = Array.from({ length: 80 }, (_, i) => ({
//       id: i,
//       x: Math.random() * 100,
//       height: 12 + Math.random() * 25,
//       width: 1.5 + Math.random() * 2.5,
//       color: `hsl(${85 + Math.random() * 15}, ${65 + Math.random() * 20}%, ${
//         30 + Math.random() * 15
//       }%)`,
//       sway: 2 + Math.random() * 8,
//       delay: Math.random() * 5,
//     }));

//     const smallRocks = Array.from({ length: 25 }, (_, i) => ({
//       id: i,
//       x: Math.random() * 100,
//       y: Math.random() * 8,
//       size: 2 + Math.random() * 10,
//       color: `hsl(${25 + Math.random() * 15}, ${25 + Math.random() * 15}%, ${
//         35 + Math.random() * 25
//       }%)`,
//     }));

//     const flowers = Array.from({ length: 12 }, (_, i) => ({
//       id: i,
//       x: Math.random() * 100,
//       y: 3 + Math.random() * 6,
//       size: 5 + Math.random() * 10,
//       color: `hsl(${Math.random() * 360}, 75%, 65%)`,
//       type: i % 4,
//     }));

//     return { grassBlades, smallRocks, flowers };
//   }, []);

//   const { grassBlades, smallRocks, flowers } = groundElements;

//   // Simplified kite position calculation
//   const calculateKitePosition = useCallback((handX, handY, threadLength = 150) => {
//     const angle = -15 + Math.random() * 30; // Reduced angle variation
//     const angleRad = (angle * Math.PI) / 180;
    
//     const kiteX = handX + Math.sin(angleRad) * threadLength;
//     const kiteY = handY - Math.cos(angleRad) * threadLength;
    
//     return { kiteX, kiteY, angle };
//   }, []);

//   const calculateRandomPositions = useCallback((kites, containerWidth, containerHeight) => {
//     if (!containerWidth || !containerHeight || containerWidth === 0) {
//       return { handPositionsMap: new Map(), kitePositionsMap: new Map() };
//     }

//     const handPositionsMap = new Map();
//     const kitePositionsMap = new Map();
//     const numKites = kites.length;
    
//     if (numKites === 0) return { handPositionsMap, kitePositionsMap };

//     const sideMargin = 30;
//     const availableWidth = Math.max(100, containerWidth - (sideMargin * 2));
//     const groundAreaTop = containerHeight * 0.75; // Higher ground area
//     const groundAreaHeight = containerHeight - groundAreaTop;
    
//     // Dynamic spacing based on available space
//     const minSpacing = Math.max(40, Math.min(80, availableWidth / Math.max(1, numKites)));

//     for (let i = 0; i < numKites; i++) {
//       const kite = kites[i];
      
//       // Distribute hands evenly across the bottom area
//       const segmentWidth = availableWidth / numKites;
//       const handX = sideMargin + (i * segmentWidth) + (Math.random() * segmentWidth * 0.6);
//       const handY = groundAreaTop + (Math.random() * groundAreaHeight * 0.5);

//       // Calculate kite position
//       const threadLength = 80 + Math.random() * 100; // Shorter threads
//       const { kiteX, kiteY, angle } = calculateKitePosition(handX, handY, threadLength);

//       // Ensure kite stays well within visible bounds
//       const safeKiteX = Math.max(20, Math.min(containerWidth - 20, kiteX));
//       const safeKiteY = Math.max(40, Math.min(containerHeight * 0.6, kiteY)); // More sky space

//       handPositionsMap.set(String(kite.kitePhotoId), {
//         x: handX,
//         y: handY,
//         rotation: -5 + Math.random() * 10, // Reduced rotation
//         threadLength: threadLength,
//       });

//       kitePositionsMap.set(String(kite.kitePhotoId), {
//         x: safeKiteX,
//         y: safeKiteY,
//         size: 50 + Math.random() * 40, // Smaller kites
//         color: threadColors[i % threadColors.length],
//         handIndex: i % handImages.length,
//         zIndex: 5 + Math.floor(Math.random() * 10),
//         angle: angle,
//       });
//     }

//     return { handPositionsMap, kitePositionsMap };
//   }, [threadColors, handImages, calculateKitePosition]);

//   const fetchKites = useCallback(async () => {
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_API_URL}all`);
//       const kites = response.data;
//       setKiteUrl(kites);

//       if (dimensions.width > 0 && dimensions.height > 0) {
//         const { handPositionsMap, kitePositionsMap } = calculateRandomPositions(
//           kites, 
//           dimensions.width, 
//           dimensions.height
//         );

//         setHandPositions(handPositionsMap);
//         setKitePositions(kitePositionsMap);
//         seenKitesRef.current = new Set(kites.map((kite) => String(kite.kitePhotoId)));
//       }
//     } catch (err) {
//       console.error("get failed", err);
//     }
//   }, [dimensions, calculateRandomPositions]);

//   const fetchKites2 = useCallback(async () => {
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_API_URL}all`);
//       setKiteUrlChange(response.data);
//     } catch (err) {
//       console.error("get failed", err);
//     }
//   }, []);

//   useEffect(() => {
//     const updateSize = () => {
//       if (containerRef.current) {
//         const { offsetWidth, offsetHeight } = containerRef.current;
//         setDimensions({
//           width: offsetWidth,
//           height: offsetHeight,
//         });
//       }
//     };

//     let resizeTimeout;
//     const handleResize = () => {
//       clearTimeout(resizeTimeout);
//       resizeTimeout = setTimeout(updateSize, 100);
//     };

//     updateSize();
//     window.addEventListener("resize", handleResize);
//     window.addEventListener("load", updateSize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//       window.removeEventListener("load", updateSize);
//       clearTimeout(resizeTimeout);
//     };
//   }, []);

//   useEffect(() => {
//     if (dimensions.width > 0 && dimensions.height > 0) {
//       fetchKites();
//     }
//   }, [dimensions, fetchKites]);

//   useEffect(() => {
//     const interval = setInterval(fetchKites2, 2000);
//     return () => clearInterval(interval);
//   }, [fetchKites2]);

//   useEffect(() => {
//     if (kiteUrlChange.length === 0 || dimensions.width === 0 || dimensions.height === 0) return;

//     const newKites = kiteUrlChange.filter(
//       (kite) => !seenKitesRef.current.has(String(kite.kitePhotoId))
//     );

//     if (newKites.length > 0) {
//       newKites.forEach((kite) => seenKitesRef.current.add(String(kite.kitePhotoId)));
//       setKiteUrl((prev) => {
//         const updated = [...prev, ...newKites];
        
//         setTimeout(() => {
//           const { handPositionsMap, kitePositionsMap } = calculateRandomPositions(
//             updated,
//             dimensions.width,
//             dimensions.height
//           );

//           setHandPositions(handPositionsMap);
//           setKitePositions(kitePositionsMap);
//           newKites.forEach((kite) =>
//             newKiteAnimationsRef.current.set(String(kite.kitePhotoId), {
//               stage: "entrance",
//               startTime: Date.now(),
//             })
//           );
//           newKites.forEach((kite) => {
//             setTimeout(() => advanceAnimationStage(kite.kitePhotoId), 1500);
//           });
//           setTimeout(() => {
//             newKites.forEach((kite) =>
//               newKiteAnimationsRef.current.delete(String(kite.kitePhotoId))
//             );
//           }, 5000);
//         }, 100);

//         return updated;
//       });
//     }
//   }, [kiteUrlChange, dimensions, calculateRandomPositions]);
//   // Animation stage progression
//   const advanceAnimationStage = useCallback((kiteId) => {
//     const current = newKiteAnimationsRef.current.get(String(kiteId));
//     if (!current) return;

//     if (current.stage === "entrance") {
//       newKiteAnimationsRef.current.set(String(kiteId), { ...current, stage: "center" });
//       setTimeout(() => advanceAnimationStage(kiteId), 1200);
//     } else if (current.stage === "center") {
//       newKiteAnimationsRef.current.set(String(kiteId), { ...current, stage: "toPosition" });
//       setTimeout(() => advanceAnimationStage(kiteId), 1300);
//     }
//   }, []);

//   // Simplified thread path calculation
//   const calculateThreadPath = useCallback((
//     handX,
//     handY,
//     handRotation,
//     kiteX,
//     kiteY
//   ) => {
//     if ([handX, handY, kiteX, kiteY].some((v) => v == null || Number.isNaN(v))) {
//       return "M 0 0 L 0 0";
//     }

//     // Simple straight line or gentle curve
//     const threadStartX = handX;
//     const threadStartY = handY - 15;

//     // Use quadratic curve for simple natural look
//     const controlX = (threadStartX + kiteX) / 2;
//     const controlY = (threadStartY + kiteY) / 2 - 20;

//     return `M ${threadStartX} ${threadStartY} Q ${controlX} ${controlY}, ${kiteX} ${kiteY}`;
//   }, []);

//   // Get wind variations for thread animation
//   const getWindVariations = useCallback((index) => {
//     return [0, 2, -1, 3, -2, 1, 0].map(strength => strength * 0.5);
//   }, []);

//   // Simplified kite animation
//   const getKiteAnimation = useCallback((position, kiteId) => {
//     const isNew = newKiteAnimationsRef.current.has(String(kiteId));
    
//     if (isNew) {
//       return {
//         x: position.x - position.size / 2,
//         y: position.y - position.size / 2,
//         scale: [0, 1],
//         opacity: [0, 1],
//         rotate: position.angle || 0,
//         transition: {
//           duration: 1.5,
//           ease: "easeOut",
//         },
//       };
//     }

//     return {
//       x: position.x - position.size / 2,
//       y: position.y - position.size / 2,
//       rotate: [position.angle || 0, (position.angle || 0) + 3, (position.angle || 0) - 2, position.angle || 0],
//       scale: 1,
//       opacity: 1,
//       transition: {
//         rotate: {
//           duration: 6,
//           repeat: Infinity,
//           ease: "easeInOut"
//         }
//       }
//     };
//   }, []);
// // NEW KITE ANIMATION - From your original code
//   const getNewKiteAnimation = useCallback((position, kiteId) => {
//     const animationState = newKiteAnimationsRef.current.get(String(kiteId));
//     const centerX = (dimensions.width / 2) - (position.size / 2);
//     const centerY = (dimensions.height / 2) - (position.size / 2);
//     const finalX = position.x - position.size / 2;
//     const finalY = position.y - position.size / 2;

//     if (animationState?.stage === "entrance") {
//       return {
//         x: [dimensions.width + 150, centerX],
//         y: [dimensions.height + 150, centerY],
//         scale: [0.5, 1],
//         opacity: [0, 1],
//         rotate: [-90, 0],
//         transition: { duration: 1.4, ease: "easeOut" },
//       };
//     } else if (animationState?.stage === "center") {
//       return {
//         x: centerX,
//         y: centerY,
//         scale: [1, 1.8, 1.5],
//         rotate: [0, 360],
//         opacity: 1,
//         transition: {
//           duration: 1.2,
//           ease: "easeInOut",
//         },
//       };
//     } else if (animationState?.stage === "toPosition") {
//       return {
//         x: [centerX, finalX],
//         y: [centerY, finalY],
//         scale: [1.5, 1],
//         rotate: [360, position.angle || 45],
//         opacity: [1, 1],
//         transition: { duration: 1.3, ease: "easeInOut" },
//       };
//     }

//     // Default idle (already in place)
//     return {
//       x: finalX,
//       y: finalY,
//       scale: 1,
//       rotate: position.angle || 45,
//       opacity: 1,
//     };
//   }, [dimensions]);

//   // Regular kite flight pattern
//   const getKiteFlightPattern = useCallback((position) => {
//     const baseRotation = position.angle || 45;
//     return {
//       rotate: [baseRotation, baseRotation + 5, baseRotation - 3, baseRotation + 2, baseRotation],
//       scale: 1,
//       opacity: 1,
//       transition: {
//         rotate: {
//           duration: 8,
//           repeat: Infinity,
//           ease: "easeInOut"
//         }
//       }
//     };
//   }, []);
//   const clouds = React.useMemo(() => [
//     { top: "5%", left: "10%", dir: "right" },
//     { top: "20%", left: "50%", dir: "left", opacity: 0.9 },
//     { top: "10%", left: "40%", dir: "right" },
//     { top: "20%", left: "20%", dir: "left", opacity: 0.6 },
//     { top: "8%", left: "85%", dir: "right" },
//     { top: "15%", left: "70%", dir: "left", opacity: 0.6 },
//   ], []);

//   const windEffects = React.useMemo(() => [1, 2, 3], []);

//   // Kite Component
//   const KiteWithHand = React.useCallback(({ url, index }) => {
//     const position = kitePositions.get(String(url.kitePhotoId));
//     const handPosition = handPositions.get(String(url.kitePhotoId));

//     if (!position || !handPosition) return null;
//     const threadColor = position.color;
//     const windVariations = getWindVariations(index);
//     const handImageIndex = position.handIndex;
//  const isNew = newKiteAnimationsRef.current.has(String(url.kitePhotoId));
//     return (
//       <React.Fragment key={String(url.kitePhotoId)}>
//         {/* Thread */}
//         <motion.svg
//           style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100%",
//             overflow: "visible",
//             pointerEvents: "none",
//             zIndex: 30,
//           }}
//           viewBox={`0 0 ${dimensions.width || 1000} ${dimensions.height || 1000}`}
//           preserveAspectRatio="none"
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           transition={{ duration: 0.3 }}
//         >
//           <motion.path
//             d={calculateThreadPath(
//               handPosition.x,
//               handPosition.y,
//               handPosition.rotation,
//               position.x,
//               position.y
//             )}
//             stroke={threadColor}
//             strokeWidth={position.row === "front" ? "2" : "1.5"}
//             fill="transparent"
//             strokeLinecap="round"
//             style={{
//               filter: `drop-shadow(1px 1px 1px rgba(0,0,0,0.2))`,
//               opacity: position.row === "front" ? 0.9 : 0.7,
//             }}
//             animate={{
//               d: windVariations.map((wind) => {
//                 const adjustedKiteX = position.x + wind * 5;
//                 const adjustedKiteY = position.y + wind * 3;
//                 return calculateThreadPath(
//                   handPosition.x,
//                   handPosition.y,
//                   handPosition.rotation,
//                   adjustedKiteX,
//                   adjustedKiteY
//                 );
//               }),
//             }}
//             transition={{
//              duration: 8 + (index % 3),
//               repeat: Infinity,
//               ease: "easeInOut",
//               delay: index * 0.3,
//             }}
//           />
//         </motion.svg>

//         {/* Kite */}
//         <motion.img
//           key={url._id}
//           src={`${process.env.REACT_APP_API_URL}file/${url.kitePhotoId}`}
//           alt={`Kite ${index + 1}`}
//           style={{
//             position: "absolute",
//             left: position.x - position.size / 2,
//             top: position.y - position.size / 2,
//             width: position.size,
//             height: position.size,
//             objectFit: "contain",
//             filter: `drop-shadow(2px 2px 4px rgba(0,0,0,0.2))`,
//             borderRadius: "5px",
//             zIndex: isNew ? 999 : position.zIndex,
//             transformOrigin: "center center",
//           }}
//           animate={
//             isNew 
//               ? getNewKiteAnimation(position, url.kitePhotoId)
//               : getKiteFlightPattern(position)
//           }
//           initial={false}
//           transition={
//                 isNew
//                   ? {
//                       duration: 4,
//                       times: [0, 0.35, 0.5, 1],
//                       ease: ["easeOut", "easeInOut", "easeOut"],
//                       rotate: {
//                         duration: 4,
//                         times: [0, 0.35, 0.65, 1],
//                         ease: ["easeOut", "linear", "easeOut"],
//                       },
//                     }
//                   : {
//                       duration: position.row === "front" ? 6 : 10,
//                       repeat: Infinity,
//                       repeatType: "loop",
//                       ease: "easeInOut",
//                     }
//               }
//         />

//         {/* Hand */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{
//             opacity: 1,
//             y: 0,
//             rotateZ: handPosition.rotation,
//           }}
//           transition={{
//                 duration: 1.5,
//                 ease: "easeOut",
//                 delay: 0.2,
//                 rotateZ: {
//                   duration: 8,
//                   repeat: Infinity,
//                   repeatType: "reverse",
//                   ease: "easeInOut",
//                   delay: index * 0.5,
//                 },
//           }}
//           style={{
//             position: "absolute",
//             left: handPosition.x - 25,
//             top: handPosition.y - 60,
//             zIndex: 30,
//             transformOrigin: "bottom center",
//             pointerEvents: "none",
//           }}
//         >
//           <img
//             src={handImages[handImageIndex]}
//             style={{
//               width: 40,
//               height: 60,
//               objectFit: "contain",
//               filter: `drop-shadow(1px 2px 3px rgba(0,0,0,0.3))`,
//               pointerEvents: "none",
//             }}
//             alt="hand holding kite"
//             loading="lazy"
//           />
//         </motion.div>
//       </React.Fragment>
//     );
//   }, [kitePositions, handPositions, dimensions, calculateThreadPath, getWindVariations, getNewKiteAnimation, getKiteFlightPattern, handImages]);

//   return (
//     <div
//       ref={containerRef}
//       style={{
//         overflow: "hidden",
//         height: "100vh",
//         width: "100vw",
//         position: "relative",
//         background: "linear-gradient(to bottom, #87CEEB 70%, #E0F7FF 100%)",
//         willChange: "transform",
//       }}
//     >
//       {/* Clouds */}
//       {clouds.map((cloud, i) => (
//         <motion.div
//           key={i}
//           animate={{
//             x: cloud.dir === "right" ? ["0%", "100%"] : ["100%", "0%"],
//           }}
//           transition={{
//             duration: 40 + i * 10,
//             repeat: Infinity,
//             ease: "linear",
//           }}
//           style={{
//             position: "absolute",
//             top: cloud.top,
//             left: cloud.left,
//             opacity: cloud.opacity ?? 1,
//             pointerEvents: "none",
//           }}
//         >
//           <img
//             src="/assets/cloud.png"
//             style={{ width: "80px", height: "80px" }}
//             alt="cloud"
//             loading="lazy"
//           />
//         </motion.div>
//       ))}

//       {/* Kites with their own hands */}
//       {kiteUrl.map((url, index) => (
//         <KiteWithHand key={String(url.kitePhotoId)} url={url} index={index} />
//       ))}

//       {/* Ground */}
//       <div
//         style={{
//           position: "absolute",
//           bottom: 0,
//           left: 0,
//           width: "100%",
//           height: "25vh", // Slightly taller ground
//           zIndex: 20,
//           overflow: "hidden",
//           background: "linear-gradient(to top, #2E7D32, #4CAF50)",
//         }}
//       >
//         {grassBlades.map((blade) => (
//           <motion.div
//             key={blade.id}
//             style={{
//               position: "absolute",
//               bottom: "10%",
//               left: `${blade.x}%`,
//               width: `${blade.width}px`,
//               height: `${blade.height}px`,
//               background: blade.color,
//               clipPath: "polygon(40% 0%, 60% 0%, 100% 100%, 0% 100%)",
//               transformOrigin: "bottom center",
//               zIndex: 21,
//             }}
//             animate={{
//               rotateZ: [-blade.sway * 0.7, blade.sway * 0.7, -blade.sway * 0.7],
//             }}
//             transition={{
//               duration: 3 + Math.random() * 2,
//               repeat: Infinity,
//               ease: "easeInOut",
//               delay: blade.delay,
//             }}
//           />
//         ))}

//         {smallRocks.map((rock) => (
//           <div
//             key={rock.id}
//             style={{
//               position: "absolute",
//               bottom: `${rock.y}%`,
//               left: `${rock.x}%`,
//               width: `${rock.size}px`,
//               height: `${rock.size * 0.6}px`,
//               background: rock.color,
//               borderRadius: "30% 70% 60% 40% / 40% 60% 70% 60%",
//               zIndex: 19,
//             }}
//           />
//         ))}

//         {flowers.map((flower) => (
//           <div
//             key={flower.id}
//             style={{
//               position: "absolute",
//               bottom: `${flower.y}%`,
//               left: `${flower.x}%`,
//               width: `${flower.size}px`,
//               height: `${flower.size}px`,
//               background: flower.color,
//               borderRadius: "50%",
//               zIndex: 20,
//             }}
//           />
//         ))}
//       </div>

//       {/* Wind effects */}
//       {windEffects.map((wind) => (
//         <motion.div
//           key={wind}
//           animate={{
//             opacity: [0, 0.2, 0],
//             x: wind % 2 === 0 ? ["-50px", "calc(100% + 50px)"] : ["calc(100% + 50px)", "-50px"],
//           }}
//           transition={{
//             duration: 15 + wind * 3,
//             repeat: Infinity,
//             delay: wind * 2,
//             ease: "linear",
//           }}
//           style={{
//             position: "absolute",
//             top: `${20 + wind * 15}%`,
//             left: wind % 2 === 0 ? "-50px" : "100%",
//             zIndex: 1,
//           }}
//         >
//           <img
//             src="/assets/windy1.png"
//             style={{
//               width: "30px",
//               height: "30px",
//               opacity: 0.3,
//             }}
//             alt="wind effect"
//             loading="lazy"
//           />
//         </motion.div>
//       ))}
//     </div>
//   );
// }
import React, { useState, useEffect, useRef, useCallback } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import "./index.css";

// Simple hash function for stable pseudo-random values based on kitePhotoId
const getStableRandom = (id, seed = 0) => {
  let hash = 0;
  const str = String(id) + seed;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash % 1000) / 1000;
};

// Unique natural flight pattern per kite (stable across refreshes)
const getUniqueFlightPattern = (kiteId, index, row, baseAngle = 45) => {
  const r = (seed) => getStableRandom(kiteId, seed);
  const frames = 8;
  const isFront = row === "front";

  // Different personality per kite
  const ampX = (isFront ? 14 : 9) * (0.55 + r(10) * 0.9);
  const ampY = (isFront ? 10 : 7) * (0.5 + r(11) * 0.95);
  const rotAmp = (isFront ? 12 : 8) * (0.45 + r(12) * 1.1);
  const windAmp = (isFront ? 1 : 0.7) * (0.6 + r(13) * 1.2);

  // Phase offsets so neighbors never sync
  const phaseX = r(20) * Math.PI * 2;
  const phaseY = r(21) * Math.PI * 2;
  const phaseR = r(22) * Math.PI * 2;
  const phaseW = r(23) * Math.PI * 2;

  // Mix 2 frequencies for less robotic motion
  const freqX1 = 1 + r(30) * 0.8;
  const freqX2 = 2 + r(31) * 1.2;
  const freqY1 = 1 + r(32) * 0.7;
  const freqY2 = 2.2 + r(33) * 1.0;
  const freqR1 = 1 + r(34) * 0.9;
  const freqW1 = 1 + r(35) * 1.1;

  const xKeys = [];
  const yKeys = [];
  const rotateKeys = [];
  const windKeys = [];

  for (let i = 0; i < frames; i++) {
    const t = i / (frames - 1);
    const a = t * Math.PI * 2;

    const x =
      Math.sin(a * freqX1 + phaseX) * ampX +
      Math.sin(a * freqX2 + phaseX * 1.3) * ampX * 0.35;
    const y =
      Math.cos(a * freqY1 + phaseY) * ampY +
      Math.sin(a * freqY2 + phaseY * 0.8) * ampY * 0.4;
    const rotate =
      baseAngle +
      Math.sin(a * freqR1 + phaseR) * rotAmp +
      Math.sin(a * 2.5 + phaseR) * rotAmp * 0.25;
    const wind =
      Math.sin(a * freqW1 + phaseW) * windAmp * 3 +
      Math.cos(a * 1.7 + phaseW) * windAmp * 1.5;

    xKeys.push(x);
    yKeys.push(y);
    rotateKeys.push(rotate);
    windKeys.push(wind);
  }

  // Close the loop smoothly
  xKeys[frames - 1] = xKeys[0];
  yKeys[frames - 1] = yKeys[0];
  rotateKeys[frames - 1] = rotateKeys[0];
  windKeys[frames - 1] = windKeys[0];

  const duration = (isFront ? 5.5 : 7.5) + r(40) * 4 + (index % 5) * 0.35;
  const delay = r(41) * 2.5 + index * 0.15;

  return {
    xKeys,
    yKeys,
    rotateKeys,
    windKeys,
    duration,
    delay,
  };
};

// Kite and Thread Component for stability
const KiteWithThread = React.memo(({ 
  url, index, position, handPosition, dimensions, isNew, animationStage,
  getNewKiteAnimation, handImages, calculateThreadPath, SAFE_EDGE 
}) => {
  const flight = React.useMemo(() => {
    if (!position) return null;
    return getUniqueFlightPattern(
      url.kitePhotoId,
      index,
      position.row,
      position.angle || 45
    );
  }, [url.kitePhotoId, index, position]);

  const { animate: kiteAnimate, transition: kiteTransition } = React.useMemo(() => {
    if (!position || !dimensions.width) {
      return { animate: {}, transition: {} };
    }
    return getNewKiteAnimation(position, dimensions, url, index, isNew, animationStage, flight);
  }, [position, dimensions, url, index, isNew, animationStage, getNewKiteAnimation, flight]);

  const size = position?.size || 80;
  const baseAngle = position?.angle || 45;
  // New-kite motion stages (kite still animates as a group)
  const isNewKiteMotion =
    isNew &&
    (animationStage === "entrance" ||
      animationStage === "center" ||
      animationStage === "toPosition");
  // Trail thread only while flying — NOT during center rotate/spin
  const showTrailThread =
    isNew &&
    (animationStage === "entrance" || animationStage === "toPosition");

  // Absolute thread (after settle / idle) — end locked to kite, curve follows kite motion
  const threadTargets = React.useMemo(() => {
    if (!position || !handPosition || !dimensions.width || !flight) return null;
    // During fly-in / rotate / fly-to-slot: no absolute person thread yet
    if (isNewKiteMotion) return null;

    const finalX = position.x;
    const finalY = position.y;

    const joinedAt = (kiteX, kiteY, wind = 0, angle = baseAngle, moveX = 0, moveY = 0) =>
      calculateThreadPath(
        handPosition.x,
        handPosition.y,
        handPosition.rotation,
        kiteX,
        kiteY,
        position.handIndex,
        wind,
        {
          kiteSize: size,
          connectToHand: true,
          kiteAngle: angle,
          moveX,
          moveY,
        }
      );

    if (isNew && animationStage === "connectHand") {
      const trailOnly = calculateThreadPath(
        handPosition.x,
        handPosition.y,
        handPosition.rotation,
        finalX,
        finalY,
        position.handIndex,
        0,
        { kiteSize: size, connectToHand: false, kiteAngle: baseAngle }
      );
      return {
        d: [trailOnly, joinedAt(finalX, finalY, 0, baseAngle)],
        opacity: [0.95, 0.75],
        transition: { duration: 1.1, ease: "easeInOut" },
      };
    }

    // Idle: identical keyframes as kite so they fly the same direction
    const idlePaths = flight.xKeys.map((x, i) => {
      const y = flight.yKeys[i];
      const prev = Math.max(0, i - 1);
      const moveX = x - flight.xKeys[prev];
      const moveY = y - flight.yKeys[prev];
      return joinedAt(finalX + x, finalY + y, flight.windKeys[i], flight.rotateKeys[i], moveX, moveY);
    });

    return {
      d: idlePaths,
      opacity: 0.75,
      transition: {
        duration: flight.duration,
        repeat: Infinity,
        repeatType: "reverse",
        ease: "easeInOut",
        delay: flight.delay,
      },
      initial: { d: idlePaths[0], opacity: 0.75 },
    };
  }, [
    isNew,
    animationStage,
    isNewKiteMotion,
    position,
    handPosition,
    dimensions,
    calculateThreadPath,
    flight,
    size,
    baseAngle,
  ]);

  if (!position || !handPosition || !dimensions.width || !flight) return null;
  if (!isNewKiteMotion && !threadTargets) return null;

  const kiteMotionKey = `${url.kitePhotoId}-${isNew ? "entering" : "flying"}`;
  const showPerson =
    !isNew || animationStage === "connectHand" || !animationStage;

  // Local trailing thread — starts behind kite center so the image covers the join
  const trailLen = Math.min(size * 0.9, 72);
  const localTrailPath = `M 0 ${-size * 0.12} C 6 ${trailLen * 0.25}, -5 ${trailLen * 0.55}, 0 ${trailLen}`;

  // Isolate each kite so a new kite's layer cannot uncover other kites' thread joins
  const wrapperZ = isNew ? 1000 : position.zIndex || 20;

  return (
    <div
      style={{
        position: "absolute",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        zIndex: wrapperZ,
        isolation: "isolate",
        pointerEvents: "none",
      }}
    >
      {/* Thread under kite (z-index 1) — join hidden behind kite image */}
      {!isNewKiteMotion && threadTargets && (
        <motion.svg
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            overflow: "visible",
            pointerEvents: "none",
            zIndex: 1,
          }}
          viewBox={`0 0 ${dimensions.width || 1000} ${dimensions.height || 1000}`}
          preserveAspectRatio="none"
        >
          <motion.path
            key={`thread-${kiteMotionKey}-${animationStage || "idle"}`}
            stroke={position.color}
            strokeWidth={isNew ? 2.2 : 1.6}
            fill="transparent"
            strokeLinecap="round"
            style={{
              filter: `drop-shadow(1px 1px 2px rgba(0,0,0,0.25)) url(#thread-glow-${index})`,
            }}
            initial={threadTargets.initial ?? false}
            animate={{
              d: threadTargets.d,
              opacity: threadTargets.opacity,
            }}
            transition={threadTargets.transition}
          />
          <defs>
            <filter id={`thread-glow-${index}`}>
              <feGaussianBlur stdDeviation="1" result="coloredBlur" />
              <feMerge>
                <feMergeNode in="coloredBlur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>
        </motion.svg>
      )}

      {/* Kite above thread (z-index 2) — covers thread start on backside */}
      <motion.div
        key={kiteMotionKey}
        style={{
          position: "absolute",
          left: position.x - size / 2,
          top: position.y - size / 2,
          width: size,
          height: size,
          zIndex: 2,
          transformOrigin: "center center",
          pointerEvents: "none",
        }}
        initial={
          isNew
            ? false
            : {
                x: flight.xKeys[0],
                y: flight.yKeys[0],
                scale: 1,
                rotate: flight.rotateKeys[0],
                opacity: position.row === "front" ? 1 : 0.8,
              }
        }
        animate={kiteAnimate}
        transition={kiteTransition}
      >
        {showTrailThread && (
          <svg
            width={size}
            height={size + trailLen + 8}
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              overflow: "visible",
              pointerEvents: "none",
              zIndex: 0,
            }}
          >
            <path
              d={localTrailPath}
              transform={`translate(${size / 2}, ${size / 2})`}
              stroke={position.color}
              strokeWidth="2.2"
              fill="transparent"
              strokeLinecap="round"
              opacity={0.95}
            />
          </svg>
        )}
        <img
          src={`${process.env.REACT_APP_API_URL}file/${url.kitePhotoId}`}
          alt={`Kite ${index + 1}`}
          style={{
            position: "relative",
            width: size,
            height: size,
            objectFit: "contain",
            filter: `drop-shadow(4px 4px 8px rgba(0,0,0,0.3)) ${position.row === "back" ? "brightness(0.9)" : ""}`,
            borderRadius: "5px",
            display: "block",
            zIndex: 1,
          }}
        />
      </motion.div>

      {/* Person above thread */}
      <motion.div
        initial={isNew ? { opacity: 0, y: 36, scale: 0.8 } : { opacity: 0, y: 20 }}
        animate={{
          opacity: showPerson ? 1 : 0,
          y: 0,
          scale: 1,
          rotateZ: showPerson
            ? [
                handPosition.rotation - (2 + getStableRandom(url.kitePhotoId, 50) * 4),
                handPosition.rotation + (2 + getStableRandom(url.kitePhotoId, 51) * 4),
                handPosition.rotation - (1 + getStableRandom(url.kitePhotoId, 52) * 3),
                handPosition.rotation,
              ]
            : handPosition.rotation,
        }}
        transition={{
          duration: isNew ? 0.85 : 1.5,
          ease: "easeOut",
          delay: isNew && animationStage === "connectHand" ? 0.2 : isNew ? 0 : 0.2,
          rotateZ: {
            duration: 6 + getStableRandom(url.kitePhotoId, 53) * 5,
            repeat: Infinity,
            repeatType: "reverse",
            ease: "easeInOut",
            delay: flight.delay,
          },
        }}
        style={{
          position: "absolute",
          left: Math.min(
            Math.max(handPosition.x, SAFE_EDGE),
            dimensions.width - SAFE_EDGE - 60
          ),
          top: handPosition.y - 70,
          zIndex: 3,
          transformOrigin: "bottom center",
          pointerEvents: "none",
          visibility: showPerson || !isNew ? "visible" : "hidden",
        }}
      >
        <img
          src={handImages[position.handIndex]}
          style={{
            width: 60,
            height: 86,
            objectFit: "contain",
            filter: `drop-shadow(2px 4px 6px rgba(0,0,0,0.4)) brightness(${position.row === "front" ? 1 : 0.9})`,
            pointerEvents: "none",
          }}
          alt="hand holding kite"
        />
      </motion.div>
    </div>
  );
});

export default function KiteDisplayPage() {
  const groundOffset = 80; // adjust so it touches hands/grass
  const [kiteUrl, setKiteUrl] = useState([]);
  const [kiteUrlChange, setKiteUrlChange] = useState([]);
  const containerRef = useRef(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [seenKites, setSeenKites] = useState(new Set());
  const [kitePositions, setKitePositions] = useState(new Map());
  const [newKiteAnimations, setNewKiteAnimations] = useState(new Map());
  const [handPositions, setHandPositions] = useState(new Map());
  const SAFE_EDGE = Math.max(0, Math.round(dimensions.width * 0.01+50)); // increase if still clipping
  // Put your hand images in /assets folder
  const handImages = [
    "/assets/person1.png",
    "/assets/person2.png",
    "/assets/person3.png",
    "/assets/person5.png",
    "/assets/person6.png",
    "/assets/person8.png",
    "/assets/person9.png",
    "/assets/person10.png",
    "/assets/person11.png",
    "/assets/person12.png",
    "/assets/person13.png",
    "/assets/person14.png",
  ];

  // Array of colorful thread colors
  const threadColors = [
    "#FF6B6B",
    "#4ECDC4",
    "#FFD93D",
    "#6B5B95",
    "#88D8B0",
    "#FFA07A",
    "#20B2AA",
    "#DA70D6",
    "#F0E68C",
    "#98D8C8",
    "#FFB6C1",
    "#7B68EE",
    "#32CD32",
    "#FF6347",
    "#9370DB",
  ];

  // Enhanced ground elements with better distribution, memoized to prevent jumping on re-renders
  const { grassBlades, smallRocks, flowers } = React.useMemo(() => {
    const grassBlades = Array.from({ length: 80 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      height: 12 + Math.random() * 25,
      width: 1.5 + Math.random() * 2.5,
      color: `hsl(${85 + Math.random() * 15}, ${65 + Math.random() * 20}%, ${
        30 + Math.random() * 15
      }%)`,
      sway: 2 + Math.random() * 8,
      delay: Math.random() * 5,
    }));

    const smallRocks = Array.from({ length: 25 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 8,
      size: 2 + Math.random() * 10,
      color: `hsl(${25 + Math.random() * 15}, ${25 + Math.random() * 15}%, ${
        35 + Math.random() * 25
      }%)`,
    }));

    const flowers = Array.from({ length: 12 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: 3 + Math.random() * 6,
      size: 5 + Math.random() * 10,
      color: `hsl(${Math.random() * 360}, 75%, 65%)`,
      type: i % 4,
    }));

    return { grassBlades, smallRocks, flowers };
  }, []);
  // Unique hand offsets for each person image to ensure thread fits exactly in their hand
  const handOffsets = {
    0: { x: 48, y: 15 }, // person1
    1: { x: 45, y: 12 }, // person2
    2: { x: 50, y: 15 }, // person3
    3: { x: 45, y: 18 }, // person5
    4: { x: 42, y: 15 }, // person6
    5: { x: 48, y: 12 }, // person8
    6: { x: 52, y: 10 }, // person9 (girl in green)
    7: { x: 45, y: 15 }, // person10
    8: { x: 45, y: 15 }, // person11
    9: { x: 45, y: 15 }, // person12
    10: { x: 45, y: 15 }, // person13
    11: { x: 45, y: 15 }, // person14
  };

  // Simplified kite position calculation with stable random angle
  const calculateKitePosition = useCallback((handX, handY, threadLength = 150, stableRandomVal = 0.5) => {
    const angle = -15 + stableRandomVal * 30; // Reduced angle variation
    const angleRad = (angle * Math.PI) / 180;
    
    const kiteX = handX + Math.sin(angleRad) * threadLength;
    const kiteY = handY - Math.cos(angleRad) * threadLength;
    
    return { kiteX, kiteY, angle };
  }, []);

  // NEW: Calculate optimal kite and hand positions that fill available space first
  const calculateOptimalPositions = (
    kites,
    containerWidth,
    containerHeight
  ) => {
    if (!containerWidth || !containerHeight || containerWidth === 0) {
      return { handPositionsMap: new Map(), kitePositionsMap: new Map() };
    }
    const handPositionsMap = new Map();
    const kitePositionsMap = new Map();

    const numKites = kites.length;
    if (numKites === 0) return { handPositionsMap, kitePositionsMap };

    const sideMargin = 60;
    const availableWidth = Math.max(100, containerWidth - (sideMargin * 2));
    const groundAreaTop = containerHeight * 0.82;
    const groundAreaHeight = containerHeight - groundAreaTop - 20;

    // Determine how many rows we need based on kite count
    const kitesPerRow = Math.min(10, Math.ceil(numKites / (numKites > 10 ? 2 : 1)));
    const numRows = Math.ceil(numKites / kitesPerRow);

    for (let i = 0; i < numKites; i++) {
      const kite = kites[i];
      const row = Math.floor(i / kitesPerRow);
      const col = i % kitesPerRow;
      const countInThisRow = Math.min(kitesPerRow, numKites - row * kitesPerRow);

      // Stable random seeds based on kitePhotoId
      const seedX = getStableRandom(kite.kitePhotoId, 0);
      const seedY = getStableRandom(kite.kitePhotoId, 1);
      const seedLength = getStableRandom(kite.kitePhotoId, 2);
      const seedAngle = getStableRandom(kite.kitePhotoId, 3);
      const seedRot = getStableRandom(kite.kitePhotoId, 4);
      const seedSize = getStableRandom(kite.kitePhotoId, 5);

      // Horizontal distribution: Stagger alternate rows by 0.5 segment width to interleave them perfectly
      const segmentWidth = availableWidth / countInThisRow;
      const rowOffset = (row % 2) * (segmentWidth / 2);
      const jitterX = (seedX * 0.4 - 0.2) * segmentWidth; // up to +/- 20% of segment width
      
      let handX = sideMargin + (col * segmentWidth) + (segmentWidth / 2) + rowOffset + jitterX;
      
      // Ensure handX wraps correctly and stays within the available bounds
      if (handX > sideMargin + availableWidth) {
        handX -= availableWidth;
      } else if (handX < sideMargin) {
        handX += availableWidth;
      }
      
      // Vertical distribution: Use stable random Y offset per row to prevent jumping
      const verticalRowOffset = (numRows - 1 - row) * (groundAreaHeight / Math.max(1, numRows));
      const handY = groundAreaTop + verticalRowOffset + (seedY * (groundAreaHeight / 2));

      // Calculate kite position with stable random thread lengths
      const threadLength = 150 + (row * 60) + seedLength * 200; // Stable length variation
      const { kiteX, kiteY } = calculateKitePosition(handX, handY, threadLength, seedAngle);

      // Calculate the real angle for the kite to point away from the hand
      const dx = kiteX - handX;
      const dy = kiteY - handY;
      const realAngle = (Math.atan2(dy, dx) * 180) / Math.PI + 90;

      // Ensure kite stays well within visible bounds (increased vertical sky range)
      const safeKiteX = Math.max(sideMargin, Math.min(containerWidth - sideMargin, kiteX));
      const safeKiteY = Math.max(50, Math.min(containerHeight * 0.65, kiteY));

      handPositionsMap.set(String(kite.kitePhotoId), {
        x: handX,
        y: handY,
        rotation: -8 + (col % 3) * 4 + (seedRot * 4),
        row: row === 0 ? "front" : "back"
      });

      kitePositionsMap.set(String(kite.kitePhotoId), {
        x: safeKiteX,
        y: safeKiteY,
        size: 80 + seedSize * 30 - (row * 10), // Back row kites are slightly smaller
        color: threadColors[i % threadColors.length],
        handIndex: i % handImages.length,
        zIndex: 30 - row,
        angle: realAngle,
        row: row === 0 ? "front" : "back"
      });
    }

    return { handPositionsMap, kitePositionsMap };
  };

  // Place one new kite in a unique free spot (different each upload, avoids existing kites)
  const placeNewKiteDifferently = (
    kite,
    existingHands,
    existingKites,
    containerWidth,
    containerHeight,
    slotIndex
  ) => {
    const sideMargin = 70;
    const availableWidth = Math.max(120, containerWidth - sideMargin * 2);
    const groundAreaTop = containerHeight * 0.82;
    const groundAreaHeight = containerHeight - groundAreaTop - 20;

    const existingHandList = [...existingHands.values()];
    const minHandGap = Math.max(55, availableWidth / 12);

    // Try several candidate spots from this kite's id so each kite lands differently
    let best = null;
    let bestScore = -1;

    for (let attempt = 0; attempt < 14; attempt++) {
      const seedX = getStableRandom(kite.kitePhotoId, 100 + attempt * 7 + slotIndex);
      const seedY = getStableRandom(kite.kitePhotoId, 200 + attempt * 11 + slotIndex);
      const seedLength = getStableRandom(kite.kitePhotoId, 300 + attempt);
      const seedAngle = getStableRandom(kite.kitePhotoId, 400 + attempt);
      const seedRot = getStableRandom(kite.kitePhotoId, 500 + attempt);
      const seedSize = getStableRandom(kite.kitePhotoId, 600 + attempt);
      const seedRow = getStableRandom(kite.kitePhotoId, 700 + attempt);

      // Spread across full ground width — not always the same column
      let handX = sideMargin + seedX * availableWidth;
      // Slight push by slot index so rapid uploads don't stack
      handX += ((slotIndex % 5) - 2) * (availableWidth * 0.04);
      if (handX < sideMargin) handX += availableWidth;
      if (handX > sideMargin + availableWidth) handX -= availableWidth;

      const isBack = seedRow > 0.55 && existingHandList.length > 3;
      const handY =
        groundAreaTop +
        (isBack ? groundAreaHeight * 0.15 : groundAreaHeight * 0.45) +
        seedY * (groundAreaHeight * 0.4);

      let minDist = Infinity;
      existingHandList.forEach((h) => {
        const d = Math.hypot(h.x - handX, h.y - handY);
        if (d < minDist) minDist = d;
      });
      if (existingHandList.length === 0) minDist = minHandGap * 2;

      const score = minDist;
      if (score > bestScore) {
        const threadLength = 140 + seedLength * 220 + (isBack ? 50 : 0);
        const { kiteX, kiteY } = calculateKitePosition(
          handX,
          handY,
          threadLength,
          seedAngle
        );
        const dx = kiteX - handX;
        const dy = kiteY - handY;
        const realAngle = (Math.atan2(dy, dx) * 180) / Math.PI + 90;
        const safeKiteX = Math.max(
          sideMargin,
          Math.min(containerWidth - sideMargin, kiteX)
        );
        const safeKiteY = Math.max(50, Math.min(containerHeight * 0.65, kiteY));

        bestScore = score;
        best = {
          hand: {
            x: handX,
            y: handY,
            rotation: -10 + seedRot * 16,
            row: isBack ? "back" : "front",
          },
          kite: {
            x: safeKiteX,
            y: safeKiteY,
            size: 75 + seedSize * 35 - (isBack ? 8 : 0),
            color: threadColors[
              Math.floor(getStableRandom(kite.kitePhotoId, 9) * threadColors.length)
            ],
            handIndex: Math.floor(
              getStableRandom(kite.kitePhotoId, 8) * handImages.length
            ),
            zIndex: isBack ? 28 : 30,
            angle: realAngle,
            row: isBack ? "back" : "front",
          },
        };

        // Good enough clearance — stop early
        if (minDist >= minHandGap) break;
      }
    }

    return best;
  };

  const fetchKites = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}all`);
      const kites = response.data;
      setKiteUrl(kites);

      // Generate optimal positions for all kites
      if (dimensions.width > 0 && dimensions.height > 0) {
        const { handPositionsMap, kitePositionsMap } =
          calculateOptimalPositions(kites, dimensions.width, dimensions.height);

        setHandPositions(handPositionsMap);
        setKitePositions(kitePositionsMap);
        setSeenKites(new Set(kites.map((kite) => String(kite.kitePhotoId))));
      }
    } catch (err) {
      console.error("get failed", err);
    }
  };

  const fetchKites2 = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}all`);
      setKiteUrlChange(response.data);
    } catch (err) {
      console.error("get failed", err);
    }
  };

  useEffect(() => {
    const updateSize = () => {
      if (containerRef.current) {
        const { offsetWidth, offsetHeight } = containerRef.current;
        setDimensions({
          width: offsetWidth,
          height: offsetHeight,
        });
      }
    };
        let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateSize, 100);
    };

    updateSize();
    window.addEventListener("resize", handleResize);
    // Also update on load complete
    window.addEventListener("load", updateSize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("load", updateSize);
      clearTimeout(resizeTimeout);
    };
  }, []);

  useEffect(() => {
    fetchKites();
  }, [dimensions]);

  useEffect(() => {
    const interval = setInterval(fetchKites2, 1000);
    return () => clearInterval(interval);
  }, [fetchKites2]);

  useEffect(() => {
    if (
      kiteUrlChange.length === 0 ||
      dimensions.width === 0 ||
      dimensions.height === 0
    )
      return;

    const newKites = kiteUrlChange.filter(
      (kite) => !seenKites.has(String(kite.kitePhotoId))
    );

    if (newKites.length > 0) {
      // Update seen kites first
      setSeenKites((prev) => {
        const updated = new Set(prev);
        newKites.forEach((kite) => updated.add(String(kite.kitePhotoId)));
        return updated;
      });

      // Add new kites to display
      setKiteUrl((prev) => [...prev, ...newKites]);

      // Place each new kite in a different free spot (keep existing kites where they are)
      setTimeout(() => {
        setHandPositions((prevHands) => {
          const nextHands = new Map(prevHands);
          const nextKites = new Map(kitePositions);

          newKites.forEach((kite, i) => {
            const id = String(kite.kitePhotoId);
            const placed = placeNewKiteDifferently(
              kite,
              nextHands,
              nextKites,
              dimensions.width,
              dimensions.height,
              nextKites.size + i
            );
            if (placed) {
              nextHands.set(id, placed.hand);
              nextKites.set(id, placed.kite);
            }
          });

          setKitePositions(nextKites);
          return nextHands;
        });

        // Start animation sequence for new kites
        setNewKiteAnimations((prev) => {
          const next = new Map(prev);
          newKites.forEach((kite) => {
            const id = String(kite.kitePhotoId);
            next.set(id, { stage: "entrance" });

            setTimeout(() => {
              setNewKiteAnimations((p) => {
                const m = new Map(p);
                if (m.has(id)) m.set(id, { stage: "center" });
                return m;
              });
            }, 1500);

            setTimeout(() => {
              setNewKiteAnimations((p) => {
                const m = new Map(p);
                if (m.has(id)) m.set(id, { stage: "toPosition" });
                return m;
              });
            }, 2800);

            setTimeout(() => {
              setNewKiteAnimations((p) => {
                const m = new Map(p);
                if (m.has(id)) m.set(id, { stage: "connectHand" });
                return m;
              });
            }, 4200);

            setTimeout(() => {
              setNewKiteAnimations((p) => {
                const m = new Map(p);
                m.delete(id);
                return m;
              });
            }, 5500);
          });
          return next;
        });
      }, 100);
    }
  }, [kiteUrlChange, dimensions, seenKites, kiteUrl]);
  
  const calculateThreadPath = (
    handX,
    handY,
    handRotation,
    kiteX,
    kiteY,
    handIndex = 0,
    windStrength = 0,
    options = {}
  ) => {
    if (
      [handX, handY, kiteX, kiteY].some((v) => v == null || Number.isNaN(v))
    ) {
      return "M 0 0 L 0 0";
    }

    const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
    const {
      kiteSize = 80,
      connectToHand = true,
      kiteAngle = 0,
      moveX = 0,
      moveY = 0,
    } = options;

    // Thread top ends at kite center — fully under the kite image (backside hidden)
    const angleRad = ((kiteAngle || 0) * Math.PI) / 180;
    const endX = kiteX;
    const endY = kiteY;

    // Trailing thread only (joined to kite, not yet to person)
    if (!connectToHand) {
      const trail = Math.min(kiteSize * 0.85, 70);
      const tipX = endX + Math.sin(angleRad) * trail;
      const tipY = endY + Math.cos(angleRad) * trail;
      const c1x = endX + Math.sin(angleRad) * trail * 0.35 + windStrength * 4;
      const c1y = endY + Math.cos(angleRad) * trail * 0.35;
      const c2x = endX + Math.sin(angleRad) * trail * 0.7 - windStrength * 3;
      const c2y = endY + Math.cos(angleRad) * trail * 0.7;
      return `M ${tipX} ${tipY} C ${c2x} ${c2y}, ${c1x} ${c1y}, ${endX} ${endY}`;
    }

    // Get offsets for this specific person
    const offsets = handOffsets[handIndex] || { x: 15, y: 15 };

    const handImageWidth = 60;
    const handImageHeight = 86;
    const actualHandX =
      clamp(handX, SAFE_EDGE, (dimensions.width || 0) - SAFE_EDGE - handImageWidth) +
      handImageWidth / 2;

    const rotationRad = (handRotation * Math.PI) / 180;

    const pivotX = actualHandX;
    const pivotY = handY - 70 + handImageHeight;

    const unrotatedHandX = offsets.x - handImageWidth / 2 + 3;
    const unrotatedHandY = -(handImageHeight - offsets.y);

    const cosTheta = Math.cos(rotationRad);
    const sinTheta = Math.sin(rotationRad);

    const threadStartX = pivotX + (unrotatedHandX * cosTheta - unrotatedHandY * sinTheta);
    const threadStartY = pivotY + (unrotatedHandX * sinTheta + unrotatedHandY * cosTheta);

    const tailLength = 30;
    const tailX =
      pivotX + (unrotatedHandX * cosTheta - (unrotatedHandY + tailLength) * sinTheta);
    const tailY =
      pivotY + (unrotatedHandX * sinTheta + (unrotatedHandY + tailLength) * cosTheta);

    const distance = Math.sqrt(
      Math.pow(endX - threadStartX, 2) + Math.pow(endY - threadStartY, 2)
    );
    const midX = (threadStartX + endX) / 2;
    const midY = (threadStartY + endY) / 2;
    const curveIntensity = Math.min(distance * 0.28, 70);

    // Curve bows with kite travel direction (same direction as kite), plus light wind
    const dirScale = 2.2;
    const control1X =
      midX - curveIntensity * 0.15 + moveX * dirScale + windStrength * 3;
    const control1Y =
      midY + curveIntensity * 0.12 + moveY * dirScale + Math.abs(moveX) * 0.15;
    const control2X =
      midX + curveIntensity * 0.2 + moveX * dirScale * 0.7 + windStrength * 5;
    const control2Y =
      midY + curveIntensity * 0.1 + moveY * dirScale * 0.7;

    return `M ${tailX} ${tailY} L ${threadStartX} ${threadStartY} C ${control1X} ${control1Y}, ${control2X} ${control2Y}, ${endX} ${endY}`;
  };


  // New kite entrance → then unique natural fly per kite
  const getNewKiteAnimation = (position, dimensions, url, index = 0, isNew = false, animationStage, flight) => {
    if (!position || !dimensions.width) {
      return { animate: {}, transition: {} };
    }

    const centerX = dimensions.width / 2 - (position.size || 80) / 2;
    const centerY = dimensions.height / 2 - position.size / 2;
    const finalX = position.x - position.size / 2;
    const finalY = position.y - position.size / 2;

    if (isNew && animationStage === "entrance") {
      return {
        animate: {
          x: [dimensions.width + 150 - finalX, centerX - finalX],
          y: [dimensions.height + 150 - finalY, centerY - finalY],
          scale: [0.5, 1],
          opacity: [0, 1],
          rotate: [-90, 0],
        },
        transition: { duration: 1.4, ease: "easeOut" },
      };
    }

    if (isNew && animationStage === "center") {
      return {
        animate: {
          x: centerX - finalX,
          y: centerY - finalY,
          scale: [1, 1.8, 1.5],
          rotate: [0, 360],
          opacity: 1,
        },
        transition: {
          duration: 1.2,
          ease: "easeInOut",
        },
      };
    }

    if (isNew && animationStage === "toPosition") {
      return {
        animate: {
          x: [centerX - finalX, 0],
          y: [centerY - finalY, 0],
          scale: [1.5, 1],
          rotate: [360, position.angle || 45],
          opacity: [1, position.row === "front" ? 1 : 0.8],
        },
        transition: { duration: 1.3, ease: "easeInOut" },
      };
    }

    // Hold in final slot while thread bottom connects to person
    if (isNew && animationStage === "connectHand") {
      return {
        animate: {
          x: 0,
          y: 0,
          scale: 1,
          rotate: position.angle || 45,
          opacity: position.row === "front" ? 1 : 0.8,
        },
        transition: { duration: 0.4, ease: "easeOut" },
      };
    }

    // Unique natural fly — different path/speed/phase per kite
    const pattern =
      flight ||
      getUniqueFlightPattern(url.kitePhotoId, index, position.row, position.angle || 45);

    return {
      animate: {
        x: pattern.xKeys,
        y: pattern.yKeys,
        scale: 1,
        rotate: pattern.rotateKeys,
        opacity: position.row === "front" ? 1 : 0.8,
      },
      transition: {
        duration: pattern.duration,
        repeat: Infinity,
        repeatType: "reverse",
        ease: "easeInOut",
        delay: pattern.delay,
      },
    };
  };

  // Animation stage management (logic moved to the trigger useEffect)
  useEffect(() => {
    // No-op - logic is now handled in the kite detecting useEffect for better stability
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        overflow: "hidden",
        height: "100vh",
        width: "100vw",
        position: "relative",
        background: "linear-gradient(to bottom, #87CEEB 70%, #E0F7FF 100%)",
      }}
    >
      {/* Clouds */}
      {[
        {
          top: "5%",
          src: "/assets/cloud.png",
          left: "10%",
          size: "1px",
          dir: "right",
        },
        {
          top: "20%",
          src: "/assets/cloud.png",
          left: "50%",
          size: "4px",
          dir: "left",
          opacity: 0.9,
        },
        {
          top: "10%",
          src: "/assets/cloud.png",
          left: "40%",
          size: "6px",
          dir: "right",
        },
        {
          top: "20%",
          src: "/assets/cloud.png",
          left: "20%",
          size: "5px",
          dir: "left",
          opacity: 0.6,
        },
        {
          top: "8%",
          src: "/assets/cloud.png",
          left: "85%",
          size: "6px",
          dir: "right",
        },
        {
          top: "15%",
          src: "/assets/cloud.png",
          left: "70%",
          size: "6px",
          dir: "left",
          opacity: 0.6,
        },
      ].map((cloud, i) => (
        <motion.div
          key={i}
          animate={{
            x: cloud.dir === "right" ? ["0%", "100%"] : ["100%", "0%"],
          }}
          transition={{
            duration: 30 + i * 5,
            repeat: Infinity,
            ease: "linear",
          }}
          style={{
            position: "absolute",
            top: cloud.top,
            left: cloud.left,
            fontSize: cloud.size,
            opacity: cloud.opacity ?? 1,
            pointerEvents: "none",
          }}
        >
          <img
            src={cloud.src}
            style={{ width: "120px", height: "120px" }}
            alt="cloud"
          />
        </motion.div>
      ))}


      {/* Kites with their own hands */}
      {kiteUrl.map((url, index) => {
        const animState = newKiteAnimations.get(String(url.kitePhotoId));
        return (
          <KiteWithThread
            key={String(url.kitePhotoId)}
            url={url}
            index={index}
            position={kitePositions.get(String(url.kitePhotoId))}
            handPosition={handPositions.get(String(url.kitePhotoId))}
            dimensions={dimensions}
            isNew={!!animState}
            animationStage={animState?.stage}
            getNewKiteAnimation={getNewKiteAnimation}
            handImages={handImages}
            calculateThreadPath={calculateThreadPath}
            SAFE_EDGE={SAFE_EDGE}
          />
        );
      })}

      {/* Enhanced Ground */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: "17vh",
          zIndex: 15,
          overflow: "hidden",
          background:
            "linear-gradient(to top, #2E7D32 0%, #388E3C 30%, #4CAF50 70%)",
        }}
      >
        {/* Grass overlay */}
        <div
          style={{
            position: "absolute",
            bottom: 10,
            left: 0,
            width: "100%",
            height: "65%",
          }}
        />

        {/* Animated grass blades */}
        {grassBlades.map((blade) => (
          <motion.div
            key={blade.id}
            style={{
              position: "absolute",
              bottom: "15%",
              left: `${blade.x}%`,
              width: `${blade.width}px`,
              height: `${blade.height}px`,
              background: blade.color,
              clipPath: "polygon(40% 0%, 60% 0%, 100% 100%, 0% 100%)",
              transformOrigin: "bottom center",
              zIndex: 16,
              boxShadow: "1px 1px 2px rgba(0,0,0,0.3)",
            }}
            animate={{
              rotateZ: [-blade.sway, blade.sway, -blade.sway],
            }}
            transition={{
              duration: 2.5 + Math.random() * 2,
              repeat: Infinity,
              ease: "easeInOut",
              delay: blade.delay,
            }}
          />
        ))}

        {/* Rocks and flowers... */}
        {smallRocks.map((rock) => (
          <div
            key={rock.id}
            style={{
              position: "absolute",
              bottom: `${rock.y}%`,
              left: `${rock.x}%`,
              width: `${rock.size}px`,
              height: `${rock.size * 0.6}px`,
              background: rock.color,
              borderRadius: "30% 70% 60% 40% / 40% 60% 70% 60%",
              boxShadow: `
                  2px 2px 4px rgba(0,0,0,0.4),
                  inset -1px -1px 2px rgba(0,0,0,0.3)
                `,
              zIndex: 15,
            }}
          />
        ))}

        {flowers.map((flower) => (
          <motion.div
            key={flower.id}
            style={{
              position: "absolute",
              bottom: `${flower.y}%`,
              left: `${flower.x}%`,
              width: `${flower.size}px`,
              height: `${flower.size}px`,
              background: flower.color,
              borderRadius:
                flower.type === 0
                  ? "50%"
                  : flower.type === 1
                  ? "50% 50% 0 0"
                  : flower.type === 2
                  ? "40% 60% 70% 30% / 50% 60% 40% 50%"
                  : "30% 70% 70% 30% / 50% 50% 50% 50%",
              boxShadow: "0 3px 6px rgba(0,0,0,0.3)",
              zIndex: 16,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: `${flower.size * 0.4}px`,
              color: "rgba(255,255,255,0.9)",
            }}
            animate={{
              y: [0, -3, 0],
              rotateZ: [0, 5, 0, -5, 0],
            }}
            transition={{
              duration: 4 + Math.random() * 4,
              repeat: Infinity,
              ease: "easeInOut",
              delay: Math.random() * 2,
            }}
          >
            {flower.type === 3 ? "✿" : ""}
          </motion.div>
        ))}
      </div>

      {/* Enhanced Wind Effects */}
      {[1, 2, 3].map((wind) => (
        <motion.div
          key={wind}
          animate={{
            opacity: [0, 0.4, 0],
            x:
              wind % 2 === 0
                ? ["-50px", "calc(100% + 50px)"]
                : ["calc(100% + 50px)", "-50px"],
          }}
          transition={{
            duration: 8 + wind * 2,
            repeat: Infinity,
            delay: wind * 1.5,
            ease: "linear",
          }}
          style={{
            position: "absolute",
            top: `${20 + wind * 15}%`,
            left: wind % 2 === 0 ? "-50px" : "100%",
            zIndex: 1,
            opacity: 0.3,
          }}
        >
          <img
            src="/assets/windy1.png"
            style={{
              width: "60px",
              height: "60px",
              filter: "brightness(1.2)",
            }}
            alt="wind effect"
          />
        </motion.div>
      ))}
    </div>
  );
}
